<template>
  <div>
    <!-- 面包屑导航 -->
    <div class="flexc-cen-x fixed">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>{{WZPBName}}</el-breadcrumb-item>
      </el-breadcrumb>
      <el-select v-if="DianList.length>1" style="margin-left:20px;width:140px" size="mini" v-model="SelectStoresID" @change="changedian()" placeholder="门店">
        <el-option
          v-for="item in DianList"
          :key="item.ID"
          :label="item.StoresName"
          :value="item.ID">
        </el-option>
      </el-select>
    </div>
   <div style="height:75vh;padding-top:30px;">
     <div class="flex-spc-x">
        <el-form :inline="true" :model="formInline"  style="height:40px;">
            <el-form-item :label="WZCDName+'：'"  prop="Site" v-if="IsCD == 1">
                <el-select v-model="site" clearable placeholder="请选择" size="mini" style="width:150px">
                      <el-option
                        v-for="item in siteList"
                        :key="item.ID"
                        :label="item.SiteName"
                        :value="item.ID">
                      </el-option>
                    </el-select>
            </el-form-item>
            <el-form-item :label="WZXMName+'：'" prop="Site">
                <el-select clearable v-model="objID" placeholder="请选择" size="mini" style="width:150px">
                      <el-option
                        v-for="item in projectList"
                        :key="item.ID"
                        :label="item.ProjectName"
                        :value="item.ID">
                      </el-option>
                    </el-select>
              </el-form-item>
            <el-form-item :label="WZXMName+'类型：'" prop="RowType" v-if="RowTypeList.length != 1">
              <el-select clearable v-model="RowType" placeholder="请选择" size="mini" style="width:150px" >
                <el-option
                  v-for="item in RowTypeList"
                  :key="item.ID"
                  :label="item.RowTypeName"
                  :value="item.ID">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="WZYGName+'：'" prop="RowType" >
              <el-select clearable v-model="LoginID" placeholder="请选择" size="mini" style="width:150px">
                      <el-option
                        v-for="item in perList"
                        :key="item.ID"
                        :label="item.Name"
                        :value="item.ID">
                      </el-option>
                    </el-select>
            </el-form-item>
            <el-form-item>
              <el-button size="mini" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
            </el-form-item>
        </el-form>
        <div class="flex-r-x" style="width:25%;display:flex;flex-wrap:wrap">
          <el-button   style="margin-bottom:10px;margin-left:10px"  size="mini" type="primary"    icon="el-icon-plus" @click="handleEdit()" v-if="q1 == true">{{WZPBName}}</el-button>
           <el-button  style="margin-bottom:10px"  size="mini"  type="warning"  v-if="type != 1 && StoresType == 1"    @click="handlesheng()" >生成图片</el-button>
             <el-button  style="margin-bottom:10px"  size="mini"  type="warning"  v-if="type == 1 && StoresType == 1"    @click="handlesheng1()" >生成图片</el-button>
           <el-button  style="margin-bottom:10px"  size="mini"  type="success" v-if="type != 1 && q5 == true"     @click="handlefu()" >复制{{WZPBName}}</el-button>
           <el-button  style="margin-bottom:10px"  size="mini" type="danger"     @click="handleDel()" v-if="q4 == true">批量删除</el-button>
        </div>
      
     </div>

   
    <!-- 搜索筛选 -->

    <!-- 分页组件 -->
      <div class="top flex-spc-x" style="width:100%;height:60px">
          <div class="flexc-cen-x">
            <el-button plain size="small" @click="toToady()">
              <span v-if="type == 1">今日</span>
              <span v-else>本周</span>
            </el-button>
                <el-button size="small" @click="toYesterDay()" style="margin-left:20px" icon="el-icon-arrow-left" circle></el-button>
                <el-button size="small" @click="toTomorrow()" style="margin-left:20px" icon="el-icon-arrow-right" circle></el-button>
                <el-date-picker
                  v-if="type == 1"
                    style="margin-left:20px"
                    v-model="date"
                    type="date"
                    size="small"
                    @change="changeDate()"
                    format="yyyy 年 MM 月 dd 日"
                    value-format="yyyy-MM-dd"
                    placeholder="选择日期">
                </el-date-picker>
                <span v-if="type == 1" style="margin-left:10px;font-weight:600">{{dayList[day]}}</span>
          </div>
          <div class="flexc-cen-x">
              <el-radio-group v-model="type" size="small" style="margin-right:40px" @change="changeType()">
                <el-radio-button label="1">日</el-radio-button>
                <el-radio-button label="2">周</el-radio-button>
              </el-radio-group>
            <div class="qie flexc-cen-x cursor" @click="toqiehuan()">
                    <img src="../../assets/img/qie1.png" style="width:20px;height:20px" alt="">
                    <span v-if="chooseTrue">{{WZYGName}}班表</span>
                    <span v-else>{{WZXMName}}班表</span>
            </div>
          </div>
      </div>
      <div class="da" ref="main">
        <div class="main flex-cen-x" v-if="type == 1">
          <div class="box flex-xy bcss">
                    <span v-if="chooseTrue == true">服务人员</span>
                    <span v-else>{{WZXMName}}</span>
          </div>
          <div class="postMain" style="z-index:9;" ref="systemForm" @scroll="sysHandleScroll()"  @mouseover="changeFlag(true)" >
              <div class="box flex-xy" style="font-weight:600;font-size:16px">
                    <span v-if="chooseTrue == true">服务人员</span>
                    <span v-else>{{WZXMName}}</span>
              </div>
              <div class="box1 flex-xy" v-if="chooseTrue == true"  style="z-index:99"  v-for="(items,index) in list">
                  <div class="flexc-cen-x" style="width:80%">
                      <img v-if="items.HeadUrl" :src="items.HeadUrl" alt="" style="width:40px;height:40px;border-radius:100%">
                      <img v-if="!items.HeadUrl" src="../../assets/img/head.png" alt="" style="width:40px;height:40px;border-radius:100%">
                      <div style="margin-left:10px">{{items.Name}}</div>
                  </div>
              </div>
                <div class="box1 flex-xy" v-if="chooseTrue == false" v-for="(items,index) in list">
                  <div class="flexc-cen-x" style="width:80%">
                      <img v-if="items.HeadUrl" :src="items.HeadUrl" alt="" style="width:40px;height:40px;border-radius:100%">
                      <img v-if="!items.HeadUrl" src="../../assets/img/head.png" alt="" style="width:40px;height:40px;border-radius:100%">
                      <div style="margin-left:10px">{{items.ProjectName}}</div>
                  </div>
                </div>
          </div>
          <div v-show="cd"   class="maxw posttrue topTime" style="width:99%;z-index:10;background-color:white"  ref="nav">
                  <div class="box flex-xy" style="font-weight:600;font-size:16px">
                      <span v-if="chooseTrue == true">服务人员</span>
                      <span v-else>{{WZXMName}}</span>
                  </div>
                  <div class="box  flexc-cen-x" style="padding-left:15px;font-weight:600;font-size:16px" v-for="(items,index) in timeData" :key="index" ref="list">
                    {{items.startTime}}
                  </div>
          </div>
          <div class="leftMain" style="width:100%" ref='externalForm' @scroll="exterHandleScroll()" @mouseover="changeFlag(true)" >

            <div class="maxw posttrue" >
                  <div class="box flex-xy" style="font-weight:600;font-size:16px">
                      <span v-if="chooseTrue == true">服务人员</span>
                      <span v-else>{{WZXMName}}</span>
                  </div>
                  <div class="box  flexc-cen-x" style="padding-left:15px;font-weight:600;font-size:16px" v-for="(items,index) in timeData" :key="index" ref="list1">
                    {{items.startTime}}
                  </div>
            </div>
              <div v-if="chooseTrue == true" class="maxw" v-for="(items,index) in list" >
                  <div class="box1 flex-xy">
                    <div class="flexc-cen-x" style="width:80%">
                          <img v-if="items.HeadUrl" :src="items.HeadUrl" alt="" style="width:40px;height:40px;border-radius:100%">
                          <img v-if="!items.HeadUrl" src="../../assets/img/head.png" alt="" style="width:40px;height:40px;border-radius:100%">
                          <div style="margin-left:10px">{{items.Name}}</div>
                    </div>
                  </div>
                  <div class="box1  flexc-cen-x" style="padding-left:15px" v-for="item in items.ListRowClass">
                      <div class="boxMain " style="height:100%;width:100%">
                        <div class="flex-xy" style="height:85%;width:100%">
                          <div v-for="(it,index) in item.ListRowClassSub" v-if="index <4" >
                            <el-popover
                            v-if="it.color"
                                placement="right-start"
                                width="220"
                                trigger="hover">
                                <div  style="width:100%">
                                    <div class="flexc-cen-x" style="border-bottom:1px solid #e6f7ff;padding-bottom:5px">
                                        <img :src="it.ProjectHeadUrl" alt="" style="width:35px;height:35px">
                                        <div style="font-size:15px;margin-left:10px">{{it.ProjectName}}</div>
                                    </div>
                                    <div v-if="it.terName" style="margin-left:10px;margin-top:10px;font-size:13px">
                                      <i class="el-icon-user"></i> 
                                      <span>{{it.terName}}</span>
                                    </div>
                                    <div v-if="it.SiteName" style="margin-left:10px;margin-top:10px;font-size:13px">
                                      <i class="el-icon-location-outline"></i> 
                                      <span>{{it.SiteName}}</span>
                                    </div>
                                    <div style="margin-left:10px;margin-top:10px;;font-size:13px">
                                      <i class="el-icon-time"></i> 
                                      <span>{{it.startTime}}</span>
                                    </div>
                                    <div class="flex-r-x" style="width:100%">
                                        <el-button type="text" @click="toEdit(it)" v-if="q2 == true">编辑</el-button>
                                        <el-button type="text" @click="todelet(it)" v-if="q3 == true" >删除</el-button>
                                        <el-button type="text" @click="toyincang(it)" v-if="q11 == true && it.Isshow == 1" >隐藏</el-button>
                                        <el-button type="text" @click="toyincang(it)" v-if="q11 == true && it.Isshow == 0" >展示</el-button>
                                    </div>
                                </div>
                                  <div class="flex-spc-x hov"  slot="reference" style="height:25px;width:190px;border-radius:2px">
                                      <div class="flexc-cen-x">
                                          <div class="qiu" :style="{'background':it.color}">
                                          </div>
                                          <div style="margin-left:10px">
                                            {{it.ProjectName}}
                                          </div>
                                    
                                      </div>
                                        <img src="../../assets/icon/yc.png" v-if="it.Isshow == 0"  style="width:20px;height:20px" alt="" srcset="">
                                      <!-- <div style="font-size:10px;color:#b3b3b3">未展示</div> -->
                                  </div>
                              </el-popover>
                          </div>
                        </div>
                        <el-popover
                          v-if="item.ListRowClassSub.length>4"
                                placement="right-start"
                                width="220"
                                trigger="hover">
                                <div  style="width:100%;height:300px; overflow: auto;">
                                    <div style="width:95%;border-top: 5px solid #e6f7ff" v-for="(it,index) in item.ListRowClassSub" >
                                      <div class="flexc-cen-x" style="border-bottom:1px solid #e6f7ff;padding-bottom:5px;padding-top:4px">
                                          <img :src="it.ProjectHeadUrl" alt="" style="width:35px;height:35px">
                                          <div style="font-size:15px;margin-left:10px">{{it.ProjectName}}</div>
                                      </div>
                                      <div v-if="it.terName" style="margin-left:10px;margin-top:10px;font-size:13px">
                                        <i class="el-icon-user"></i> 
                                        <span>{{it.terName}}</span>
                                      </div>
                                      <div v-if="it.SiteName" style="margin-left:10px;margin-top:10px;font-size:13px">
                                        <i class="el-icon-location-outline"></i> 
                                        <span>{{it.SiteName}}</span>
                                      </div>
                                      <div style="margin-left:10px;margin-top:10px;;font-size:13px">
                                        <i class="el-icon-time"></i> 
                                        <span>{{it.startTime}}</span>
                                      </div>
                                      <div class="flex-r-x" style="width:100%">
                                          <el-button type="text" @click="toEdit(it)" v-if="q2 == true">编辑</el-button>
                                          <el-button type="text" @click="todelet(it)" v-if="q3 == true">删除</el-button>
                                          <el-button type="text" @click="toyincang(it)" v-if="q11 == true && it.Isshow == 1" >隐藏</el-button>
                                        <el-button type="text" @click="toyincang(it)" v-if="q11 == true && it.Isshow == 0" >展示</el-button>
                                      </div>
                                    </div>
                                  
                                </div>
                                  <div class="quanbu " style="margin-left:120px"   slot="reference" >显示全部({{item.ListRowClassSub.length}})</div>
                              </el-popover>

                      
                      </div>
                  </div>
                  
              </div>
              <div v-if="chooseTrue == false" class="maxw" v-for="(items,index) in list">
                  <div class="box1 flex-xy">
                    <div class="flexc-cen-x" style="width:80%"> 
                          <img v-if="items.HeadUrl" :src="items.HeadUrl" alt="" style="width:40px;height:40px;border-radius:100%">
                          <img v-if="!items.HeadUrl" src="../../assets/img/head.png" alt="" style="width:40px;height:40px;border-radius:100%">
                          <div style="margin-left:10px">{{items.ProjectName}}</div>
                    </div>
                  </div>
                  <div class="box1  flexc-cen-x" style="padding-left:15px" v-for="item in items.ListRowClass">
                      <div class="boxMain " style="height:100%;width:100%">
                        <div class="flex-xy" style="height:85%;width:100%">
                          <div v-for="(it,index) in item.ListRowClassSub" v-if="index <4" >
                            <el-popover
                            v-if="it.terName"
                                placement="right-start"
                                width="220"
                                trigger="hover">
                                <div  style="width:100%">
                                    <div class="flexc-cen-x" style="border-bottom:1px solid #e6f7ff;padding-bottom:5px">
                                      <img v-if="it.terHeadUrl !=''" :src="it.terHeadUrl" alt="" style="width:35px;height:35px;border-radius:100%">
                                      <img v-else src="../../assets/img/head.png" alt="" style="width:35px;height:35px;border-radius:100%">
                                        <!-- <img :src="it.ProjectHeadUrl" alt="" style="width:35px;height:35px"> -->
                                        <div style="font-size:15px;margin-left:10px">{{it.terName}}</div>
                                    </div>
                                    <div  style="margin-left:10px;margin-top:10px;font-size:13px">
                                      <i class="el-icon-document"></i> 
                                      <span>{{it.ProjectName}}</span>
                                    </div>
                                    <div v-if="it.SiteName" style="margin-left:10px;margin-top:10px;font-size:13px">
                                      <i class="el-icon-location-outline"></i> 
                                      <span>{{it.SiteName}}</span>
                                    </div>
                                    <div style="margin-left:10px;margin-top:10px;;font-size:13px">
                                      <i class="el-icon-time"></i> 
                                      <span>{{it.startTime}}</span>
                                    </div>
                                    <div class="flex-r-x" style="width:100%">
                                      <el-button type="text" @click="toEdit(it)" v-if="q2 == true">编辑</el-button>
                                      <el-button type="text" @click="todelet(it)" v-if="q3 == true">删除</el-button>
                                     <el-button type="text" @click="toyincang(it)" v-if="q11 == true && it.Isshow == 1" >隐藏</el-button>
                                        <el-button type="text" @click="toyincang(it)" v-if="q11 == true && it.Isshow == 0" >展示</el-button>
                                    </div>
                                </div>
                                  <div class="flex-spc-x hov"  slot="reference" style="height:25px;width:190px;border-radius:2px">
                                    <div class="flexc-cen-x">
                                      <img v-if="it.terHeadUrl !=''" :src="it.terHeadUrl" alt="" style="width:20px;height:20px;border-radius:100%">
                                      <img v-else src="../../assets/img/head.png" alt="" style="width:20px;height:20px;border-radius:100%">
                                    <!-- <div class="qiu" :style="{'background':it.color}">
                                    </div> -->
                                      <div style="margin-left:10px">
                                        {{it.terName}}
                                      </div>
                                    </div>
                                   
                                      <img src="../../assets/icon/yc.png" v-if="it.Isshow == 0"  style="width:20px;height:20px" alt="" srcset="">
                                  </div>
                              </el-popover>
                          </div>
                        </div>
                        <el-popover
                          v-if="item.ListRowClassSub.length>4"
                                placement="right-start"
                                width="220"
                                trigger="hover">
                                <div  style="width:100%;height:300px; overflow: auto;">
                                    <div style="width:95%;border-top: 5px solid #e6f7ff" v-for="(it,index) in item.ListRowClassSub" >
                                      <div class="flexc-cen-x" style="border-bottom:1px solid #e6f7ff;padding-bottom:5px;padding-top:4px">
                                        <img v-if="it.terHeadUrl !=''" :src="it.terHeadUrl" alt="" style="width:35px;height:35px;border-radius:100%">
                                        <img v-else src="../../assets/img/head.png" alt="" style="width:35px;height:35px;border-radius:100%">
                                        <div style="font-size:15px;margin-left:10px">{{it.terName}}</div>
                                      </div>
                                      <div  style="margin-left:10px;margin-top:10px;font-size:13px">
                                        <i class="el-icon-document"></i> 
                                        <span>{{it.ProjectName}}</span>
                                      </div>
                                      <div v-if="it.SiteName" style="margin-left:10px;margin-top:10px;font-size:13px">
                                        <i class="el-icon-location-outline"></i> 
                                        <span>{{it.SiteName}}</span>
                                      </div>
                                      <div style="margin-left:10px;margin-top:10px;;font-size:13px">
                                        <i class="el-icon-time"></i> 
                                        <span>{{it.startTime}}</span>
                                      </div>
                                      <div class="flex-r-x" style="width:100%">
                                            <el-button type="text" @click="toEdit(it)" v-if="q2 == true">编辑</el-button>
                                            <el-button type="text" @click="todelet(it)" v-if="q3 == true">删除</el-button>
                                            <el-button type="text" @click="toyincang(it)" v-if="q11 == true && it.Isshow == 1" >隐藏</el-button>
                                        <el-button type="text" @click="toyincang(it)" v-if="q11 == true && it.Isshow == 0" >展示</el-button>
                                      </div>
                                    </div>
                                  
                                </div>
                                  <div class="quanbu " style="margin-left:180px"   slot="reference" >显示全部({{item.ListRowClassSub.length}})</div>
                              </el-popover>

                      
                      </div>
                  </div>
                  
              </div>


          
          </div>
        </div>
        <div class="main flex-cen-x" v-else>
          <div class="box flex-xy bcss">
                    <span v-if="chooseTrue == true">服务人员</span>
                    <span v-else>{{WZXMName}}</span>
          </div>
          <div class="postMain" style="z-index:9;" ref="systemForm" @scroll="sysHandleScroll()"  @mouseover="changeFlag(true)" >
              <div class="box flex-xy" style="font-weight:600;font-size:16px">
                    <span v-if="chooseTrue == true">服务人员</span>
                    <span v-else>{{WZXMName}}</span>
              </div>
              <div class="box1 flex-xy" v-if="chooseTrue == true"  style="z-index:99"  v-for="(items,index) in list">
                  <div class="flexc-cen-x" style="width:80%">
                        <img v-if="items.HeadUrl" :src="items.HeadUrl" alt="" style="width:40px;height:40px;border-radius:100%">
                        <img v-if="!items.HeadUrl" src="../../assets/img/head.png" alt="" style="width:40px;height:40px;border-radius:100%">
                        <div style="margin-left:10px">{{items.Name}}</div>
                  </div>
              </div>
              <div class="box1 flex-xy" v-if="chooseTrue == false" v-for="(items,index) in list">
                  <div class="flexc-cen-x" style="width:80%">
                        <img v-if="items.HeadUrl" :src="items.HeadUrl" alt="" style="width:40px;height:40px;border-radius:100%">
                        <img v-if="!items.HeadUrl" src="../../assets/img/head.png" alt="" style="width:40px;height:40px;border-radius:100%">
                        <div style="margin-left:10px">{{items.ProjectName}}</div>
                  </div>
              </div>
          </div>
          <div v-show="cd"    class="maxw posttrue topTime" style="width:99%;z-index:10;background-color:white"  ref="nav">
                  <div class="box flex-xy" style="font-weight:600;font-size:16px">
                      <span v-if="chooseTrue == true">服务人员</span>
                      <span v-else>{{WZXMName}}</span>
                  </div>
                  <div class="box  flexc-cen-x" style="padding-left:15px;font-weight:600;font-size:16px" v-for="(items,index) in timeData" :key="index" ref="list">
                    <div>
                      {{items.weekstr}}
                    </div>
                    <div style="margin-left:10px">
                        {{items.Stime}}
                    </div>
                    <img v-if="today == items.Stime"  src="../../assets/toady.png" style="margin-left:10px;width:20px;height:20px" alt="" srcset="">
                  </div>
          </div>
          <div class="leftMain" style="width:100%" ref='externalForm' @scroll="exterHandleScroll()" @mouseover="changeFlag(true)" >

            <div class="maxw posttrue" >
                  <div class="box flex-xy" style="font-weight:600;font-size:16px">
                      <span v-if="chooseTrue == true">服务人员</span>
                      <span v-else>{{WZXMName}}</span>
                  </div>
                  <div class="box  flexc-cen-x" style="padding-left:15px;font-weight:600;font-size:16px" v-for="(items,index) in timeData" :key="index" ref="list">
                    <div>
                      {{items.weekstr}}
                    </div>
                    <div style="margin-left:10px">
                        {{items.Stime}}
                    </div>
                    
                  </div>
            </div>
              <div v-if="chooseTrue == true" class="maxw" v-for="(items,index) in list" >
                  <div class="box1 flex-xy">
                    <div class="flexc-cen-x" style="width:80%">
                          <img v-if="items.HeadUrl" :src="items.HeadUrl" alt="" style="width:40px;height:40px;border-radius:100%">
                          <img v-if="!items.HeadUrl" src="../../assets/img/head.png" alt="" style="width:40px;height:40px;border-radius:100%">
                          <div style="margin-left:10px">{{items.Name}}</div>
                    </div>
                  </div>
                  <div class="box1  flexc-cen-x " style="padding-left:15px" v-for="item in items.ListRowClass">
                      <div class="boxMain " style="height:100%;width:100%">
                        <div class="flex-xy" style="height:85%;width:100%">
                          <div v-for="(it,index) in item.ListRowClassSub" v-if="index <4" >
                            <el-popover
                            v-if="it.color"
                                placement="right-start"
                                width="220"
                                trigger="hover">
                                <div  style="width:100%">
                                    <div class="flexc-cen-x" style="border-bottom:1px solid #e6f7ff;padding-bottom:5px">
                                        <img :src="it.ProjectHeadUrl" alt="" style="width:35px;height:35px">
                                        <div style="font-size:15px;margin-left:10px">{{it.ProjectName}}</div>
                                    </div>
                                    <div v-if="it.terName" style="margin-left:10px;margin-top:10px;font-size:13px">
                                      <i class="el-icon-user"></i> 
                                      <span>{{it.terName}}</span>
                                    </div>
                                    <div v-if="it.SiteName" style="margin-left:10px;margin-top:10px;font-size:13px">
                                      <i class="el-icon-location-outline"></i> 
                                      <span>{{it.SiteName}}</span>
                                    </div>
                                    <div style="margin-left:10px;margin-top:10px;;font-size:13px">
                                      <i class="el-icon-time"></i> 
                                      <span>{{it.startTime}}</span>
                                    </div>
                                    <div class="flex-r-x" style="width:100%">
                                        <el-button type="text" @click="toEdit(it)" v-if="q2 == true">编辑</el-button>
                                        <el-button type="text" @click="todelet(it)" v-if="q3 == true" >删除</el-button>
                                   <el-button type="text" @click="toyincang(it)" v-if="q11 == true && it.Isshow == 1" >隐藏</el-button>
                                        <el-button type="text" @click="toyincang(it)" v-if="q11 == true && it.Isshow == 0" >展示</el-button>
                                    </div>
                                </div>
                                  <div class="flex-spc-x hov cursor"  slot="reference" style="height:25px;width:190px;border-radius:2px">
                                    <div class="flexc-cen-x">
                                        <div class="qiu" :style="{'background':it.color}">
                                        </div>
                                      <div style="margin-left:10px">
                                        {{it.ProjectName}}
                                      </div>
                                    </div>
                                     <img src="../../assets/icon/yc.png" v-if="it.Isshow == 0"  style="width:20px;height:20px" alt="" srcset="">
                                  </div>
                              </el-popover>
                          </div>
                        </div>
                        <el-popover
                          v-if="item.ListRowClassSub.length>4"
                                placement="right-start"
                                width="220"
                                trigger="hover">
                                <div  style="width:100%;height:300px; overflow: auto;">
                                    <div style="width:95%;border-top: 5px solid #e6f7ff" v-for="(it,index) in item.ListRowClassSub" >
                                      <div class="flexc-cen-x" style="border-bottom:1px solid #e6f7ff;padding-bottom:5px;padding-top:4px">
                                          <img :src="it.ProjectHeadUrl" alt="" style="width:35px;height:35px">
                                          <div style="font-size:15px;margin-left:10px">{{it.ProjectName}}</div>
                                      </div>
                                      <div v-if="it.terName" style="margin-left:10px;margin-top:10px;font-size:13px">
                                        <i class="el-icon-user"></i> 
                                        <span>{{it.terName}}</span>
                                      </div>
                                      <div v-if="it.SiteName" style="margin-left:10px;margin-top:10px;font-size:13px">
                                        <i class="el-icon-location-outline"></i> 
                                        <span>{{it.SiteName}}</span>
                                      </div>
                                      <div style="margin-left:10px;margin-top:10px;;font-size:13px">
                                        <i class="el-icon-time"></i> 
                                        <span>{{it.startTime}}</span>
                                      </div>
                                      <div class="flex-r-x" style="width:100%">
                                          <el-button type="text" @click="toEdit(it)" v-if="q2 == true">编辑</el-button>
                                          <el-button type="text" @click="todelet(it)" v-if="q3 == true">删除</el-button>
                                   <el-button type="text" @click="toyincang(it)" v-if="q11 == true && it.Isshow == 1" >隐藏</el-button>
                                        <el-button type="text" @click="toyincang(it)" v-if="q11 == true && it.Isshow == 0" >展示</el-button>
                                      </div>
                                    </div>
                                  
                                </div>
                                <div class="quanbu cursor" style="margin-left:120px"   slot="reference" >显示全部({{item.ListRowClassSub.length}})</div>
                              </el-popover>
                      </div>
                  </div>
                  
              </div>
              <div v-if="chooseTrue == false" class="maxw" v-for="(items,index) in list">
                <div class="box1 flex-xy">
                    <div class="flexc-cen-x" style="width:80%">
                          <img v-if="items.HeadUrl" :src="items.HeadUrl" alt="" style="width:40px;height:40px;border-radius:100%">
                          <img v-if="!items.HeadUrl" src="../../assets/img/head.png" alt="" style="width:40px;height:40px;border-radius:100%">
                          <div style="margin-left:10px">{{items.ProjectName}}</div>
                    </div>
                </div>
                <div class="box1  flexc-cen-x" style="padding-left:15px" v-for="item in items.ListRowClass">
                      <div class="boxMain " style="height:100%;width:100%">
                        <div class="flex-xy" style="height:85%;width:100%">
                          <div v-for="(it,index) in item.ListRowClassSub" v-if="index <4" >
                            <el-popover
                            v-if="it.terName"
                                placement="right-start"
                                width="220"
                                trigger="hover">
                                <div  style="width:100%">
                                    <div class="flexc-cen-x" style="border-bottom:1px solid #e6f7ff;padding-bottom:5px">
                                      <img v-if="it.terHeadUrl !=''" :src="it.terHeadUrl" alt="" style="width:35px;height:35px;border-radius:100%">
                                      <img v-else src="../../assets/img/head.png" alt="" style="width:35px;height:35px;border-radius:100%">
                                        <!-- <img :src="it.ProjectHeadUrl" alt="" style="width:35px;height:35px"> -->
                                        <div style="font-size:15px;margin-left:10px">{{it.terName}}</div>
                                    </div>
                                    <div  style="margin-left:10px;margin-top:10px;font-size:13px">
                                      <i class="el-icon-document"></i> 
                                      <span>{{it.ProjectName}}</span>
                                    </div>
                                    <div v-if="it.SiteName" style="margin-left:10px;margin-top:10px;font-size:13px">
                                      <i class="el-icon-location-outline"></i> 
                                      <span>{{it.SiteName}}</span>
                                    </div>
                                    <div style="margin-left:10px;margin-top:10px;;font-size:13px">
                                      <i class="el-icon-time"></i> 
                                      <span>{{it.startTime}}</span>
                                    </div>
                                    <div class="flex-r-x" style="width:100%">
                                        <el-button type="text" @click="toEdit(it)" v-if="q2 == true">编辑</el-button>
                                        <el-button type="text" @click="todelet(it)" v-if="q3 == true">删除</el-button>
                                     <el-button type="text" @click="toyincang(it)" v-if="q11 == true && it.Isshow == 1" >隐藏</el-button>
                                        <el-button type="text" @click="toyincang(it)" v-if="q11 == true && it.Isshow == 0" >展示</el-button>
                                    </div>
                                </div>
                                  <div class="flex-spc-x hov cursor"  slot="reference" style="height:25px;width:190px;border-radius:2px">
                                    <div class="flexc-cen-x">
                                      <img v-if="it.terHeadUrl !=''" :src="it.terHeadUrl" alt="" style="width:20px;height:20px;border-radius:100%">
                                        <img v-else src="../../assets/img/head.png" alt="" style="width:20px;height:20px;border-radius:100%">
                                      <!-- <div class="qiu" :style="{'background':it.color}">
                                      </div> -->
                                      <div style="margin-left:10px">
                                        {{it.terName}}
                                      </div>
                                    </div>
                                     <img src="../../assets/icon/yc.png" v-if="it.Isshow == 0"  style="width:20px;height:20px" alt="" srcset="">
                                  </div>
                              </el-popover>
                          </div>
                        </div>
                        <el-popover
                          v-if="item.ListRowClassSub.length>4"
                                placement="right-start"
                                width="220"
                                trigger="hover">
                                <div  style="width:100%;height:300px; overflow: auto;">
                                    <div style="width:95%;border-top: 5px solid #e6f7ff" v-for="(it,index) in item.ListRowClassSub" >
                                      <div class="flexc-cen-x" style="border-bottom:1px solid #e6f7ff;padding-bottom:5px;padding-top:4px">
                                        <img v-if="it.terHeadUrl !=''" :src="it.terHeadUrl" alt="" style="width:35px;height:35px;border-radius:100%">
                                        <img v-else src="../../assets/img/head.png" alt="" style="width:35px;height:35px;border-radius:100%">
                                        <div style="font-size:15px;margin-left:10px">{{it.terName}}</div>
                                      </div>
                                      <div  style="margin-left:10px;margin-top:10px;font-size:13px">
                                        <i class="el-icon-document"></i> 
                                        <span>{{it.ProjectName}}</span>
                                      </div>
                                      <div v-if="it.SiteName" style="margin-left:10px;margin-top:10px;font-size:13px">
                                        <i class="el-icon-location-outline"></i> 
                                        <span>{{it.SiteName}}</span>
                                      </div>
                                      <div style="margin-left:10px;margin-top:10px;;font-size:13px">
                                        <i class="el-icon-time"></i> 
                                        <span>{{it.startTime}}</span>
                                      </div>
                                      <div class="flex-r-x" style="width:100%">
                                          <el-button type="text" @click="toEdit(it)" v-if="q2 == true">编辑</el-button>
                                          <el-button type="text" @click="todelet(it)" v-if="q3 == true">删除</el-button>
                                          <el-button type="text" @click="toyincang(it)" v-if="q11 == true && it.Isshow == 1" >隐藏</el-button>
                                        <el-button type="text" @click="toyincang(it)" v-if="q11 == true && it.Isshow == 0" >展示</el-button>
                                      </div>
                                    </div>
                                  
                                </div>
                                  <div class="quanbu cursor" style="margin-left:180px"   slot="reference" >显示全部({{item.ListRowClassSub.length}})</div>
                              </el-popover>

                      
                      </div>
                </div>
              </div>
          </div>

        </div>
      </div>
   </div>
    <!-- 编辑界面 -->
    <el-drawer :wrapperClosable= false :title="title" :visible.sync="editFormVisible" :direction="direction" size="50%">

      <el-form label-width="140px" :model="editForm" :rules="rules" ref="editForm" style="margin-bottom:100px">
        <el-form-item label="排班方式：" prop="dateType">
             <el-radio-group v-model="dateType" @change="changeDateType">
                <el-radio label="1">按日</el-radio>
                <el-radio label="2">按时间范围</el-radio>
            </el-radio-group>
        </el-form-item>
        <el-form-item label="日期：" prop="startTime" v-if="dateType == 1">
          <el-date-picker 
              v-model="editForm.startTime"
              type="date"
              size="mini"
              placeholder="选择日期"
              value-format="yyyy-MM-dd">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="周期：" prop="Cycle" v-if="!isEdit && dateType == 2">
            <el-checkbox-group v-model="checkedCycles" @change="handleChange">
                <el-checkbox v-for="item in CycleList" :label="item.Id" :key="item.index" name="Cycle">
                    {{item.Label}}
                </el-checkbox>
            </el-checkbox-group>
            <div class="inputSubLabel">多选周期可批量{{WZPBName}}</div>
        </el-form-item>
        <el-form-item label="时间范围：" prop="startTime" v-if="dateType == 2">
            <el-date-picker 
                            v-model="editForm.startTime"
                            type="date"
                            size="mini"
                            @change="changeTime"
                            placeholder="开始日期"
                            value-format="yyyy-MM-dd">
            </el-date-picker> 
            <span v-if="!isEdit "> 至 </span>
            <el-date-picker v-if="!isEdit "
                        size="mini"
                            v-model="editForm.endTime"
                            type="date"
                            @change="changeTime"
                            placeholder="结束日期"
                            value-format="yyyy-MM-dd">
            </el-date-picker>
            <div  class="inputSubLabel">时间范围就是这一次{{WZPBName}}有效的日期范围，比如从5月1日至5月31日；系统将自动在这个范围内，去检索上面“周一到周日”所勾选的“周几”进行{{WZPBName}}</div>
        </el-form-item>
        <el-form-item :label="WZXMName+'：'" prop="objID">
            <div class="flexc-cen-x" style="width:100%">
                    <img v-if="objitems.HeadUrl" :src="objitems.HeadUrl"  style="width:40px;height:40px;border-radius:100%" alt="">
                <div style="margin-left:10px;font-size:16px;font-weight:600">
                    {{objitems.ProjectName}}
                </div>
                <div>
                    <el-button bian  @click="tochooseObj()"  type="text" style="margin-right:10px;margin-left:10px">选择</el-button>
                </div>
                
            </div>

        </el-form-item>
        <el-form-item :label="WZXMName+'时长：'" prop="Timelength">
            <el-input v-model="editForm.Timelength" size="small" v-on:input="inputLapse(editForm.Timelength)" style="width:150px;"></el-input> 分钟
        </el-form-item>
        <el-form-item :label="WZCDName+'：'" prop="Site" v-if="IsCD == 1">
          <el-select v-model="editForm.Site" placeholder="请选择" size="small">
                <el-option
                  v-for="item in siteList"
                  :key="item.ID"
                  :label="item.SiteName"
                  :value="item.ID">
                </el-option>
              </el-select>
              <el-button type="text" @click="toSite">设置</el-button>
        </el-form-item>
        <el-form-item :label="WZYGName+'：'" prop="LoginIDs">
            <div class="flexc-cen-x" style="width:100%">
                <div style="display:flex;flex-wrap:wrap;">
                    <div v-for="(items,index) in LoginIDs" style="margin-left:5px">{{items.name}}
                        <span v-if="index < LoginIDs.length - 1">,</span>
                    </div>       
                </div>
                <div>
                  <el-button bian  @click="toPerson()"  type="text" style="margin-right:10px;margin-left:10px">选择</el-button>
                </div>         
            </div>
        </el-form-item>
        <el-form-item :label="WZPBName+'类别：'" prop="RowType" v-if="editForm.RowType !='' && RowTypeList.length != 1 " >
              <div >{{editForm.RowTypeName}}</div>
        </el-form-item>
        <el-form-item label="支持会员卡：" v-if="isCard == 1 && objitems.allCardName && objitems.allCardName !=''">
            <div class="flexc-cen-x" style="width:100%">
                <div style="margin-left:10px;font-size:16px;">
                    {{objitems.allCardName}}
                </div>
            </div>
        </el-form-item>
        <el-form-item label="消耗金额：" prop="xhAmount" v-if="editForm.iscx == 1 && isCard == 1 ">
          <el-input v-model="editForm.xhAmount" size="small" type="number"   style="width:150px;"></el-input> 元
        </el-form-item>
        <el-form-item label="消耗次数：" prop="iscx" v-if="editForm.isck == 1 && isCard == 1">
          <el-input v-model="editForm.xhnumber" size="small" type="number"   style="width:150px;"></el-input> 次
          <!-- <el-input-number v-model="editForm.xhnumber" :min="0" :step="0.1" size="small" step-strictly></el-input-number> 次 -->
        </el-form-item>
        <el-form-item :label="WZPBName+'方式：'" prop="RowClassType" v-if="editForm.RowType != 1 && editForm.RowType !=''">
             <el-radio-group v-model="editForm.RowClassTypeqt" @change="changeOptions1">
                <el-radio label="1">全天</el-radio>
                <el-radio label="2">自定义</el-radio>
            </el-radio-group>
        </el-form-item>
        <el-form-item label="时间间隔：" prop="Timelengthqt" v-if="editForm.RowClassTypeqt == 1">
          <el-select v-model="editForm.Timelengthqt" placeholder="请选择" size="small" style="width:150px;" @change="getRowClassTimsqt">
                <el-option
                  v-for="item in timechoose"
                  :key="item.value"
                  :label="item.value"
                  :value="item.value">
                </el-option>
              </el-select>
              分钟
        </el-form-item>
                <el-form-item label="开启最低人数限制：" prop="ismincount" v-if="editForm.RowType == 1 && editForm.RowType !=''">
             <el-radio-group v-model="editForm.ismincount">
                <el-radio label="1">是</el-radio>
                <el-radio label="0">否</el-radio>
            </el-radio-group>
        </el-form-item>
        
        <el-form-item label="预约时间表：" v-if="editForm.RowClassTypeqt== 2 && parseInt(editForm.Timelength)>0" prop="RowClassType">
            <el-button type="default" size="mini" @click="RowClassTimeClick">添加时间表</el-button>
            <div class="g-items-wrap f-mt-10 " >
                <div class="itemWrap___33SF3"  v-for="item in listRowClassTime" :key="item.index" :id="item.ID" >
                    <span v-if="item.state !='3'" >{{item.startTime}} ~ {{item.endTime}}</span>
                </div>
            </div>
        </el-form-item>
        <el-form-item label="预约时间表：" v-if="editForm.RowClassTypeqt== 1 && parseInt(editForm.Timelength)>0" prop="RowClassType">
                         <el-button type="primary" size="mini" @click="RowClassTimeqzClick">重置</el-button>
                        <div class="g-items-wrap f-mt-10"  style="display: flex;flex-wrap: wrap;">
                        <div class="itemWrap___33SF31"  v-for="item in listRowClassTimeQT" :key="item.index" :id="item.ID" >
                        <span >{{item.startTime}}</span>
                         <i class="el-icon-delete" v-if="title != '修改'" @click="deleteRowClassTimeqt(item,item.index)"></i>
                        </div>
                    </div>
        </el-form-item>

        <el-form-item label="允许无卡预约：" prop="PreAboutType" v-if=" isCard == 1 ">
             <el-radio-group v-model="editForm.PreAboutType">
                <el-radio label="2">是</el-radio>
                <el-radio label="1">否</el-radio>
            </el-radio-group>
        </el-form-item>
        <el-form-item label="允许储蓄卡：" prop="iscx" v-if=" isCard == 0 ">
             <el-radio-group v-model="editForm.iscx">
                <el-radio label="1">是</el-radio>
                <el-radio label="0">否</el-radio>
            </el-radio-group>
        </el-form-item>
        <el-form-item label="消耗金额：" prop="xhAmount" v-if="editForm.iscx == 1 && isCard == 0 ">
          <el-input v-model="editForm.xhAmount" size="small" type="number"   style="width:150px;"></el-input> 元
        </el-form-item>
        <el-form-item label="允许次卡：" prop="isck" v-if=" isCard == 0">
             <el-radio-group v-model="editForm.isck">
                <el-radio label="1">是</el-radio>
                <el-radio label="0">否</el-radio>
            </el-radio-group>
        </el-form-item>
        <el-form-item label="消耗次数：" prop="iscx" v-if="editForm.isck == 1 && isCard == 0">
          <el-input v-model="editForm.xhnumber" size="small" type="number"   style="width:150px;"></el-input> 次
        </el-form-item>
        <el-form-item label="开启线上支付：" prop="IsPay" v-if="IsPay == 1 &&  gkIsPay == 1">
             <el-radio-group v-model="editForm.IsPay">
                <el-radio label="1">是</el-radio>
                <el-radio label="0">否</el-radio>
            </el-radio-group>
        </el-form-item>
        <el-form-item label="支付金额：" prop="xhAmount" v-if="editForm.IsPay == 1">
          <el-input v-model="editForm.payPrice" size="small" type="number"  placeholder="支付金额" style="width:150px;"></el-input> 元
        </el-form-item>
        <el-form-item label="开启预约资料:" prop="isPreAboutInfo" v-if="IsPBZL == 1">
            <el-radio-group v-model="editForm.isPreAboutInfo">
              <el-radio :label="1">是</el-radio>
              <el-radio :label="0">否</el-radio>
            </el-radio-group>
        </el-form-item>
        <el-form-item label="预约资料:" v-if="editForm.isPreAboutInfo == 1">
          <el-button bian  type="text" @click="openPreAbout()">编辑</el-button>
        </el-form-item>
        <div v-for="(items,index) in editForm.ListPreAboutForms" v-if="items.state !=3" style="margin-bottom:15px;">
            <div>
         <!-- el-icon-s-grid -->
                <span v-if="items.isbt == 1" style="margin-left:5%;color:red">*</span>
                <span v-if="items.isbt == 0" style="margin-left:5%;color:white">*</span>
                <span>{{items.Title}}<span v-if="items.fType == 1" ><i class="el-icon-s-order" style="margin-left:4px"></i>:</span>
                  <span v-if="items.fType == 2"><i class="el-icon-s-grid" style="margin-left:4px"></i>：</span></span>
             </div>
        </div>
      </el-form>
        <div class="demo-drawer__footer flex-r-x"  style="width:50%">
          <el-button size="small" @click="closeDialog">取消</el-button>
          <el-button
            style="margin-right:20px"
            size="small"
            type="primary"
            @click="submitForm('editForm')"
            >保存</el-button>
        </div>
    </el-drawer>
    <el-drawer :wrapperClosable= false title="编辑" :visible.sync="editShow" :direction="direction" size="50%">
      <el-form label-width="140px" :model="editForm" :rules="rules" ref="editForm" style="margin-bottom:100px">
     
        <el-form-item :label="WZXMName+'：'" prop="objID">
            <div class="flexc-cen-x" style="width:100%">
                    <img v-if="objitems.HeadUrl" :src="objitems.HeadUrl"  style="width:40px;height:40px;border-radius:100%" alt="">
                <div style="margin-left:10px;font-size:16px;font-weight:600">
                    {{objitems.ProjectName}}
                </div>
                <div>
                    <el-button bian  @click="tochooseObj()"  type="text" style="margin-right:10px;margin-left:10px">选择</el-button>
                </div>
                
            </div>
            

        </el-form-item>
        <el-form-item :label="WZXMName+'时长：'" prop="Timelength">
            <el-input v-model="editForm.Timelength" size="small"  v-on:input="inputLapse(editForm.Timelength)" style="width:150px;"></el-input> 分钟
        </el-form-item>
        <el-form-item :label="WZCDName+'：'" prop="Site" v-if="IsCD == 1">
          <el-select v-model="editForm.Site" placeholder="请选择" size="small">
                <el-option
                  v-for="item in siteList"
                  :key="item.ID"
                  :label="item.SiteName"
                  :value="item.ID">
                </el-option>
              </el-select>
               <el-button type="text" @click="toSite">设置</el-button>
        </el-form-item>
        <el-form-item :label="WZYGName+'：'" prop="LoginIDs" >
            <div class="flexc-cen-x" style="width:100%">
                <div style="display:flex;flex-wrap:wrap;">
                    <div  style="margin-left:5px">{{personName}}
                        
                    </div>
                  
                </div>
                <div>
                    <el-button bian  @click="toPerson1()"  type="text" style="margin-right:10px;margin-left:10px">选择</el-button>
                </div>
                
            </div>
           
          
        </el-form-item>
        <el-form-item :label="WZPBName+'类别：'" prop="RowType"  v-if="editForm.RowType !='' && RowTypeList.length != 1 ">
              <div>{{editForm.RowTypeName}}</div>
        </el-form-item>
        <el-form-item label="支持会员卡：" v-if="isCard == 1 && objitems.allCardName && objitems.allCardName !=''">
            <div class="flexc-cen-x" style="width:100%">
                <div style="margin-left:10px;font-size:16px;">
                    {{objitems.allCardName}}
                </div>
            </div>
        </el-form-item>
        <el-form-item label="消耗金额：" prop="xhAmount" v-if="editForm.iscx == 1 && isCard == 1 ">
          <el-input v-model="editForm.xhAmount" size="small" type="number"   style="width:150px;"></el-input> 元
        </el-form-item>
       <el-form-item label="消耗次数：" prop="iscx" v-if="editForm.isck == 1 && isCard == 1">
          <el-input v-model="editForm.xhnumber" size="small" type="number"   style="width:150px;"></el-input> 次
        </el-form-item>
        <el-form-item :label="WZPBName+'方式：'" prop="RowClassType" v-if="editForm.RowType != 1 && editForm.RowType !=''">
             <el-radio-group v-model="editForm.RowClassTypeqt" @change="changeOptions1">
                <el-radio label="1">全天</el-radio>
                <el-radio label="2">自定义</el-radio>
            </el-radio-group>
        </el-form-item>
        <el-form-item label="时间间隔：" prop="Timelengthqt" v-if="editForm.RowClassTypeqt == 1">
            <el-select v-model="editForm.Timelengthqt" placeholder="请选择" size="small" style="width:150px;" @change="getRowClassTimsqt">
                  <el-option
                    v-for="item in timechoose"
                    :key="item.value"
                    :label="item.value"
                    :value="item.value">
                  </el-option>
            </el-select> 
            分钟
        </el-form-item>
        <el-form-item label="开启最低人数限制：" prop="ismincount" v-if="editForm.RowType == 1 && editForm.RowType !=''">
             <el-radio-group v-model="editForm.ismincount">
                <el-radio label="1">是</el-radio>
                <el-radio label="0">否</el-radio>
            </el-radio-group>
        </el-form-item>
        
        <el-form-item label="预约时间表：" v-if="editForm.RowClassTypeqt== 2 && parseInt(editForm.Timelength)>0" prop="RowClassType">
            <el-button type="default" size="mini" @click="RowClassTimeClick">添加时间表</el-button>
            <div class="g-items-wrap f-mt-10 " >
                <div class="itemWrap___33SF3"  v-for="item in listRowClassTime" :key="item.index" :id="item.ID" >
                    <span v-if="item.state !='3'" >{{item.startTime}} ~ {{item.endTime}}</span>
                </div>
            </div>
        </el-form-item>
         <el-form-item label="预约时间表：" v-if="editForm.RowClassTypeqt== 1 && parseInt(editForm.Timelength)>0" prop="RowClassType">
                         <el-button type="primary" size="mini" @click="RowClassTimeqzClick">重置</el-button>
                        <div class="g-items-wrap f-mt-10"  style="display: flex;flex-wrap: wrap;">
                        <div class="itemWrap___33SF31"  v-for="item in listRowClassTimeQT" :key="item.index" :id="item.ID" >
                        <span >{{item.startTime}}</span>
                         <i class="el-icon-delete" v-if="!isEditqt" @click="deleteRowClassTimeqt(item,item.index)"></i>
                        </div>
                    </div>
        </el-form-item>

        <el-form-item label="允许无卡预约：" prop="PreAboutType" v-if=" isCard == 1 ">
             <el-radio-group v-model="editForm.PreAboutType">
                <el-radio label="2">是</el-radio>
                <el-radio label="1">否</el-radio>
            </el-radio-group>
        </el-form-item>
        <el-form-item label="允许储蓄卡：" prop="iscx" v-if=" isCard == 0 ">
             <el-radio-group v-model="editForm.iscx">
                <el-radio label="1">是</el-radio>
                <el-radio label="0">否</el-radio>
            </el-radio-group>
        </el-form-item>
        <el-form-item label="消耗金额：" prop="xhAmount" v-if="editForm.iscx == 1&& isCard == 0 ">
          <el-input v-model="editForm.xhAmount" size="small" type="number"   style="width:150px;"></el-input> 元
        </el-form-item>
        <el-form-item label="允许次卡：" prop="isck" v-if="isCard == 0">
             <el-radio-group v-model="editForm.isck">
                <el-radio label="1">是</el-radio>
                <el-radio label="0">否</el-radio>
            </el-radio-group>
        </el-form-item>
        <el-form-item label="消耗次数：" prop="iscx" v-if="editForm.isck == 1 && isCard == 0">
          <el-input v-model="editForm.xhnumber" size="small" type="number"   style="width:150px;"></el-input> 次
        </el-form-item>
        <el-form-item label="开启线上支付：" prop="IsPay" v-if="IsPay == 1 &&  gkIsPay == 1">
             <el-radio-group v-model="editForm.IsPay">
                <el-radio label="1">是</el-radio>
                <el-radio label="0">否</el-radio>
            </el-radio-group>
        </el-form-item>
        <el-form-item label="支付金额：" prop="xhAmount" v-if="editForm.IsPay == 1">
          <el-input v-model="editForm.payPrice" size="small" type="number"  placeholder="支付金额" style="width:150px;"></el-input> 元
        </el-form-item>


          <!-- <el-form-item label="预约方式：" prop="preAboutType">
              <el-radio-group v-model="editForm.preAboutType" >
                            <el-radio label="1">会员/非会员</el-radio>
                            <el-radio label="2">会员</el-radio>
                            <el-radio label="3">非会员</el-radio>
                        </el-radio-group>
          </el-form-item> -->
        <el-form-item label="开启预约资料:" prop="isPreAboutInfo" v-if="IsPBZL == 1">
            <el-radio-group v-model="editForm.isPreAboutInfo">
              <el-radio :label="1">是</el-radio>
              <el-radio :label="0">否</el-radio>
            </el-radio-group>
        </el-form-item>
        <el-form-item label="预约资料:" v-if="editForm.isPreAboutInfo == 1">
                <el-button bian type="text" @click="openPreAbout()">编辑</el-button>
        </el-form-item>
        <div v-for="(items,index) in editForm.ListPreAboutForms" v-if="items.state !=3" style="margin-bottom:15px;">
            <div>
         <!-- el-icon-s-grid -->
                <span v-if="items.isbt == 1" style="margin-left:5%;color:red">*</span>
                <span v-if="items.isbt == 0" style="margin-left:5%;color:red"> </span>
                <span>{{items.Title}}<span v-if="items.fType == 1" ><i class="el-icon-s-order" style="margin-left:4px"></i>:</span>
                <span v-if="items.fType == 2"><i class="el-icon-s-grid" style="margin-left:4px"></i>：</span></span>
             </div>
              <div style="margin-left:50px;">
                <el-input size="small"  type="number" auto-complete="off" :disabled="true"  style="width: 215px;margin-top:10px"></el-input>
              </div>
          
                
                  <!-- <span style="margin-left:5%">名称：{{}}</span> -->
        </div>
      </el-form>
 
        <div class="demo-drawer__footer flex-r-x"  style="width:50%">
          <el-button size="small" @click="closeDialog">取消</el-button>
          <el-button
          style="margin-right:20px"
            size="small"
            type="primary"
            @click="sub('editForm')"
            >保存</el-button
          >
        </div>
    </el-drawer>
     <el-dialog title="预约资料" :visible.sync="preShow" width="800px" @click="closeDialog1">
      <div class="flex-spc-x" style="width:98%;margin-left:1%;height:400px">
        <div class="right" style="height:100%;width:27%" > 
            <div class="flex-xy"  style="margin-bottom:20px">通用格式</div>
            <el-button plain class="el-icon-s-order" @click="toadd('1')"> 文本</el-button>
            <el-button plain class="el-icon-s-grid" @click="toadd('2')"> 时间</el-button>
        </div>
        <div class="left flex-xy" style="width:73%;height:100%">
            <div class="mainTitle">
                <div class="" style="font-size:20px;margin-left:5px;margin-top:5px;font-weight:500">预约资料表</div>
                <div  class="mian" style="margin-top:10px;width:100%" :key="timer" @dragover="dragover($event)">
                  <transition-group class="transition-wrapper" name="sort">
                    <div v-for="(items,index) in ListPreAboutForms" class="hen flex-xy" :key='items.length' v-if="items.state != 3" style="margin-top:10px"   
                      :draggable="true"
                      @dragstart="dragstart(items)"
                      @dragenter="dragenter(items,$event)"
                      @dragend="dragend(items,$event)"
                      @dragover="dragover($event)">

                      <div class="flex-spc-x" style="font-size:15px;width:100%;">
                        <span v-if="items.fType == 1" style="margin-left:5%">文本</span>
                        <span v-if="items.fType == 2" style="margin-left:5%">时间</span>
                        <i class="el-icon-delete-solid coBlue" style="margin-right:2%;font-size:15px" @click="todel(items,index)"></i>
                        <!-- <el-button size="mini" style="margin-right:10px" type="info" @click="todel(items,index)">删除</el-button> -->
                      </div>
                      <div class="flexc-cen-x"  style="margin-top:5px">
                        <el-select v-model="items.isbt" placeholder="选择" size="mini" style="width:80px">
                          <el-option
                            v-for="item in lay"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                          </el-option>
                        </el-select>
                        <el-input size="mini" v-model="items.Title" placeholder="请输入标题" style="width:350px;margin-left:10px"></el-input>
                      </div>
                     
                    </div>
                  </transition-group>
                  
                </div>
   
            </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="preShow = false">取消</el-button>
        <el-button size="small" type="primary" :loading="loading"  @click="save()">保存</el-button>
      </div>
    </el-dialog>
     <el-dialog :title="'选择'+WZYGName" :visible.sync="personShow" width="500px" >
        <div class="dialogMain" style="width:100%;height:400px">
            <el-collapse accordion  >
                <el-collapse-item v-for="(items) in personList" :key="items.ID" >
                    <template slot="title">
                            <!-- <img src="../../assets/icon/choose.png" alt="" style="width:18px;height:18px">   -->
                            <span style="margin-left:5px">{{items.Name}}</span>
                    </template>
                    <div class="cursor" v-for="item in items.listsub" :key="item.ID" style="margin-left:20px" @click="choose(item)" >
                        <div class="flexc-cen-x" style="margin-top:5px" :key="thier" > 
                            <img v-if="item.show == true" src="../../assets/icon/choose.png" alt="" style="width:18px;height:18px">
                             <img v-if="!item.show" src="../../assets/icon/nochoose.png" alt="" style="width:18px;height:18px">
                            <div style="margin-left:5px;font-size:15px">
                                {{item.Name}}
                            </div>                   
                        </div> 
                    </div>
                </el-collapse-item>

            </el-collapse>
            <div class=" dilag-fix flex-r-x" >
          <el-button size="small" @click="personShow = false">取消</el-button>
          <el-button
          style="margin-right:20px"
            size="small"
            type="primary"
      
        
            @click="surePerson()"
            >确定</el-button
          >
            </div>
        </div>
    </el-dialog>
    <el-dialog :title="'选择'+WZXMName" :visible.sync="objShow" width="700px" @click="closeDialog">
      <el-table  :data="projectList" highlight-current-row v-loading="loading"  element-loading-text="拼命加载中" style="width: 100%;">
        <!-- <el-table-column align="center" type="selection" width="60">
        </el-table-column> -->
          <el-table-column  prop="HeadUrl" label="头像" align="center" >
            <template slot-scope="scope">
              <div class="flex-xy">
                <img :src="scope.row.HeadUrl" v-if="scope.row.HeadUrl !='' " style="width:25px;height:25px;border-radius:100%" alt="">
                <img v-if="scope.row.HeadUrl =='' " src="../../assets/img/head.png" style="width:25px;height:25px;border-radius:100%" alt="">
              </div>
            </template>
          </el-table-column>
          <el-table-column  prop="ProjectName" label="名称" align="center" >
          
          </el-table-column>
          <el-table-column  prop="RowTypeName" label="类型" align="center"  v-if="RowTypeList.length != 1 ">
          
          </el-table-column>
        <el-table-column align="center" label="操作"  >
          <template slot-scope="scope">
            <el-button size="mini" type="primary" @click="sureProject(scope.row)">选择</el-button>
          </template>
        </el-table-column>
      </el-table>
      <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
        <div slot="footer" class="dialog-footer">
              <el-button size="small" @click="objShow = false">取消</el-button>
              <!-- <el-button size="small" type="primary" :loading="loading"  @click="save()">保存</el-button> -->
        </div>
    </el-dialog>
    <el-drawer :wrapperClosable= false
            class="normalDrawer"
            title="添加时间表"
            direction="rtl"
            size="50%"
            :visible.sync="RowClassTimeShow"
 
            >          
            <div class="drawerForm" style="width:95%;margin-left:2.5%">
                <div>
                    <el-alert
                        title="安排一个或多个时间段，让学员选择预约"
                        type="warning" :closable="false"
                        show-icon>
                    </el-alert>
                    <div class=" f-mt-10" >
                      <el-table
                          :data="listRowClassTime"
                          style="width: 100%">
                          <el-table-column
                            align="center"
                            prop="date"
                            label="时间"
                           >
                           <template slot-scope="scope">
                             <span>{{scope.row.startTime}} ~ {{scope.row.endTime}}</span>
                          <!-- <el-button @click="handleClick(scope.row)" type="text" size="small">查看</el-button>
                          <el-button type="text" size="small">编辑</el-button> -->
                          </template>
                          </el-table-column>
                          <el-table-column
                            align="center"
                            prop="MinCount"
                            label="最小人数"
                            v-if="  editForm.ismincount == 1"
                            >
                          
                          </el-table-column>
                          <el-table-column
                            align="center"
                            prop="limitCount"
                            label="最大人数">
                          </el-table-column>
                          <el-table-column
                            fixed="right"
                            label="操作"
                            width="120">
                            <template slot-scope="scope">
                               <el-button @click="handleXiu(scope.$index, scope.row)" type="text" size="small">修改</el-button> 
                                <el-button  @click.native.prevent="deleteRow(scope.$index, listRowClassTime,scope.row)" type="text" size="small">删除</el-button>
                            </template>
                          </el-table-column>
                        </el-table>
                        <!-- <div class="itemWrap___33SF3"  v-for="item in listRowClassTime" :key="item.index" :id="item.ID" >
                        <span v-if="item.state !='3'" >{{item.startTime}} ~ {{item.endTime}}</span>
                        <i class="el-icon-delete" v-if="item.state !='3'"  @click="deleteRowClassTime(item,item.index)"></i>
                        </div> --> 
                    </div>
                      <div style="margin-top:20px;margin-bottom:100px">
                        <span style="font-size:12px;margin-left:10px">{{WZPBName}}时间：</span>

                        <el-select  v-model="editForm.shour" size="small" style="width:90px;" @input="forceUpdate"   @change="changeshour1">
                          
                            <el-option  v-for="item in coursetime" 
                              :value="item.value" 
                              :label="item.label" 
                              :key="item.value">
                            </el-option>
                        </el-select>   :  
                        <el-select size="small" v-model="editForm.sminute" style="width:90px;" @input="forceUpdate"   @change="changesminute1" >
                            <el-option v-for="item in coursetminu" :value="item.value" :label="item.label" :key="item.value">
                            </el-option>
                        </el-select> 
                      <div style="margin-top:10px"    v-if="  editForm.ismincount == 1">
                        <span style="font-size:12px;margin-left:10px;">最小人数：</span> <el-input-number v-model="MinCount" :min="1" :step="1" size="small" step-strictly></el-input-number>
                      </div>
                       
                      <div style="margin-top:10px"> 
                         <span style="font-size:12px;margin-left:10px;">最大人数：</span> <el-input-number v-model="limitCount" :min="1" :step="1" size="small" step-strictly></el-input-number>
                    
                      </div>
                          <el-button style="margin-top:15px" icon="el-icon-plus" size="small" type="primary" @click="addRowClassTimeClick1" >添加</el-button>
                      </div>
                </div>
            </div>
    </el-drawer>
    <el-dialog
        title="提示"
        :visible.sync="copyShow"
        width="30%"
        >
        <div class="flex-xy" style="font-size:16px" v-if="isCopy == 0">确定将当前课表复制到下一周吗？</div>
        <div class="flex-xy" style="font-size:16px" v-if="isCopy == 1">下一周已存在课表，确定将当前课表复制到下一周吗？</div>
        
 
        <span slot="footer" class="dialog-footer">
          <el-button @click="copyShow = false">取 消</el-button>
          <el-button type="primary"  @click="toCopy(0)">确 定</el-button>
           <el-button type="primary" v-if="isCopy == 1" @click="toCopy(1)">清空下一周并复制</el-button>
        </span>
      </el-dialog>
      <el-dialog :title="'选择'+WZYGName" :visible.sync="personShow1" width="500px" @click="personShow1 = false">
        <div class="dialogMain" style="width:100%;height:400px">
            <el-collapse accordion  >
                <el-collapse-item v-for="(items) in personList" :key="items.ID" >
                    <template slot="title">
                            <!-- <img src="../../assets/icon/choose.png" alt="" style="width:18px;height:18px">   -->
                            <span style="margin-left:5px">{{items.Name}}</span>
                    </template>
                    <div class="cursor" v-for="item in items.listsub" :key="item.ID" style="margin-left:20px" @click="choose(item)" >
                        <div class="flex-spc-x" style="margin-top:5px" > 
                            
                            <div style="margin-left:5px;font-size:15px">
                                {{item.Name}}
                            </div>
                            <el-button type="text">选择</el-button>
                        </div> 
                        
                    </div>
                </el-collapse-item>

            </el-collapse>

        </div>
    </el-dialog>
     <el-dialog :title="WZCDName" :visible.sync="siteShow" width="600px" @click="siteShow = false">
       <div class="flex-spc-x" style="margin-top:-20px">
         <div></div>
          <el-button size="mini" type="primary" icon="el-icon-plus"  v-if="q1 == true"  @click="handleEdit1()">添加{{WZCDName}}类别</el-button>
       </div>
        
      <el-table  :data="siteList" highlight-current-row v-loading="loading" size="mini"  element-loading-text="拼命加载中" style="width:100%;margin-top:10px">
             <el-table-column  prop="SiteName" :label="WZCDName+'名称'">
            
        </el-table-column>
      <el-table-column align="center" label="操作" width="200" >
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit1(scope.row)" >编辑</el-button>
          <el-button size="mini" type="info" v-if="q3 ==true" @click="deleteUser1(scope.row)" >删除</el-button>
        </template>
      </el-table-column>
    </el-table>
     </el-dialog>
         <el-drawer :wrapperClosable= false :title="title1" :visible.sync="editFormVisible1" :direction="direction" size="30%">
       <el-form label-width="120px" :model="editForm1" :rules="rules1" ref="editForm1">
         <el-form-item :label="WZCDName+'名称:'" prop="SiteName">
          <el-input size="small" v-model="editForm1.SiteName" auto-complete="off" placeholder="请输入名称"  style="width: 215px"></el-input>
        </el-form-item>
     
      </el-form>
 
        <div class="demo-drawer__footer flex-r-x"  style="width:30%">
          <el-button size="small" @click="editFormVisible1 = false">取消</el-button>
          <el-button
          style="margin-right:20px"
            size="small"
            type="primary"
      
        
            @click="submitForm1('editForm1')"
            >保存</el-button
          >
        </div>
    </el-drawer>
   
    <el-dialog title="修改时间" :visible.sync="editFormTimeVisible" :direction="direction" width="500px" > 
   
      <el-form label-width="120px" ref="editForm1">
        <el-form-item label="预约时间'" prop="SiteName">
          <span>{{TimeInfo.startTime}} ~ {{TimeInfo.endTime}}</span>
         </el-form-item>
        <el-form-item v-if="  editForm.ismincount == 1" label="最小人数" prop="SiteName">
          <el-input-number v-model="TimeInfo.MinCount" :min="1" :step="1" size="small" step-strictly></el-input-number>
          </el-form-item>
        <el-form-item label="最大人数" prop="SiteName">
          <el-input-number v-model="TimeInfo.limitCount" :min="1" :step="1" size="small" step-strictly></el-input-number>
        </el-form-item>
      </el-form>

        <div slot="footer" class="dialog-footer">
            <el-button size="small"  @click="submitFormTimecoles()">取消</el-button>
            <el-button size="small" type="primary"   @click="submitFormTime()">确定</el-button>
        </div>

  </el-dialog>
    <!-- siteList -->
    <!-- </el-dialog> -->
  </div>
</template>
<script src="https://cdn.bootcss.com/jquery/3.2.1/jquery.js"></script>
<script>
var throttle = require('lodash/throttle')
import { deptList, deptSave, deptDelete } from '../../api/userMG'
import CropperImage from "../../components/CropperImage";
import {getListManageLogin,addManageLogin,delManageLogin,editManageLogin,editManageLoginmoney,editManageLoginPwd,editManageLoginIsdisable} from "@/api/getData";
import Pagination from '../../components/Pagination'
import draggable from 'vuedraggable'
export default {
  data() {
    return {
      type:"2",
      day:'',
      chooseTrue:true,
      editFormTimeVisible:false,
      TimeInfo:{},
      limitCountCopy:0, 
      MinCountCopy:0,
      timeindex:0,
      isFixed: false, //是否固定的
      throttleScroll: null, //定义一个截流函数的变量
      RowType:'',
       IsCD:localStorage.getItem("IsCD"),
      WZCDName:localStorage.getItem('WZCDName'),
      dayList:[
          '周日',
          '周一',
          '周二',
          '周三',
          '周四',
          '周五',
          '周六',
        ],
         isCard:localStorage.getItem("isCard"),
        RowTypeList:[
          {value:'班课',
            ID:'1'
          },{
            value:'私教',
            ID:'2'
          },{
            value:'精品课',
            ID:'3'
          }
        ],
        RowClassTimeShow:false,
        siteList:[],
        isEditqt:false,
        editShow:false,
        IsPay:localStorage.getItem("IsPay"),
        hyIsPay:localStorage.getItem("hyIsPay"),
        spIsPay:localStorage.getItem("spIsPay"),
        gkIsPay:localStorage.getItem("gkIsPay"),
        hdIsPay:localStorage.getItem("hdIsPay"),
        xmIsPay:localStorage.getItem("xmIsPay"),
        IsPBZL:localStorage.getItem("IsPBZL"),
        site:'',
        personName:'',
        thier:'',
        coursetime:[{
          value: '00',
          label: '00'
        }, {
          value: '01',
          label: '01'
        }, {
          value: '02',
          label: '02'
        }, {
          value: '03',
          label: '03'
        }, {
          value: '04',
          label: '04'
        }, {
          value: '05',
          label: '05'
        }, {
          value: '06',
          label: '06'
        }, {
          value: '07',
          label: '07'
        }, {
          value: '08',
          label: '08'
        }, {
          value: '09',
          label: '09'
        }, {
          value: '10',
          label: '10'
        }, {
          value: '11',
          label: '11'
        }, {
          value: '12',
          label: '12'
        }, {
          value: '13',
          label: '13'
        }, {
          value: '14',
          label: '14'
        }, {
          value: '15',
          label: '15'
        }, {
          value: '16',
          label: '16'
        }, {
          value: '17',
          label: '17'
        }, {
          value: '18',
          label: '18'
        }, {
          value: '19',
          label: '19'
        }, {
          value: '20',
          label: '20'
        }, {
          value: '21',
          label: '21'
        }, {
          value: '22',
          label: '22'
        }, {
          value: '23',
          label: '23'
        }]
      //  ,coursetminu:[{
      //    value: '00',
      //    label: '00'
      //  }, {
      //    value: '15',
      //     label: '15'
      //   }, {
      //     value: '30',
      //     label: '30'
      //   }, {
      //     value: '45',
      //     label: '45'
      //   }]
           ,coursetminu:[{
            value: '00',
            label: '00'
         }, {
           value: '05',
           label: '05'
         }, {
           value: '10',
           label: '10'
         }, {
           value: '15',
           label: '15'
         }, {
           value: '20',
           label: '20'
         }, {
           value: '25',
           label: '25'
         }, {
           value: '30',
           label: '30'
        }, {
           value: '35',
           label: '35'
         }, {
           value: '40',
           label: '40'
        }, {
           value: '45',
           label: '45'
         }, {
           value: '50',
           label: '50'
         }, {
           value: '55',
           label: '55'
         }]
        ,
          CycleList:[
                    {Id:"1",Label:"周一"},
                    {Id:"2",Label:"周二"},
                    {Id:"3",Label:"周三"},
                    {Id:"4",Label:"周四"},
                    {Id:"5",Label:"周五"},
                    {Id:"6",Label:"周六"},
                    {Id:"7",Label:"周日"}
                ],
                checkedCycles:[],
   
      objShow:false,
      listRowClassTimeQT:[],
      listRowClassTime:[],
      listRowClassTimeCopy:[],
      list:[],
      isweek:0,
      copyShow:false,
      direction: "ltr",
      nshow: true, //switch开启
      fshow: false, //switch关闭
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      date:'', 
      LoginIDs:[],
      SelectStoresID:localStorage.getItem("StoresID"),
      startTimenew:"08:00",
      RowClasendTime:"",
      today:'',
      editForm: {
        RowType:'',
        shour:'',
        sminute:'',
        RowClassType:1,
        SiteName:'',
        isPreAboutInfo:0,
        ListPreAboutForms:[],
        ListRowClassTime:" ",
        LoginIDs:'',
        Timelength:'',
        objID:'',
        RowClassTypeqt:'1',
        xhAmount:0,
        payPrice:0,
        iscx:'1',
        isck:'0',
        xhnumber:0,
        Timelengthqt:30,
        integral:0,
        IsPay:'0',
        PreAboutType:1,
        ismincount:0,
        // preferentialType:0,
        // LevelName:'',
        // preferentialvalue:'',
      },
    Limits:[],
    q1:false,
    q2:false,
    q3:false,
    q11:false,
    timeData:[],
    iscx:'',
    isck:'',
      // rules表单验证
    preShow:false,
    title:'',
    rules1: {

        SiteName: [{ required: true, message: '请输入名称', trigger: 'blur' }],

      },
      rules: {
        // Cycle:[{ required: true, message: '请选择周期', trigger: 'blur' }],
        objID: [{ required: true, message: '请选择项目', trigger: 'blur' }],
        RowType:[{required: true, message: '请选择类别', trigger: 'blur'}]
        //   Phone: [{ required: true, message: '请输入联系电话', trigger: 'blur' }],
        //   Name: [{ required: true, message: '请输入联系人', trigger: 'blur' }],
        //   pwd: [{ required: true, message: '请输入密码', trigger: 'blur' }],
        //   money: [{ required: true, message: '请输入余额', trigger: 'blur' }],
        //   ShopName: [{ required: true, message: '请输入商户名称', trigger: 'blur' }],
      },
      formInline: {
        page: 1,
        limit:10,

      },
      timechoose:[
          {
          value:15,
        },
        {
          value:30,
        },
        {
          value:45,
        },
        {
          value:60,
        },
         {
          value:90,
        },
         {
          value:120,
        }
      ],
       lay:[
        {
          value:'1',
          label:'必填'
        },
            {
          value:'0',
          label:'选填'
        }
      ],
      timer:'',
      isCopy:'',
      isEdit:false,
      objitems:{},
      personList:[],
      RowTypeList:[],
      projectList:[],
      cd:false,
      editFormVisible1:false,
      title1:'',
      editForm1:{},
      Site:'',
      LoginID:'',
      objID:'',
      limitCount:1,
      MinCount:1,
      perList:[],
      // 删除部门
      seletedata: {
        ids: '',
        token: localStorage.getItem('logintoken')
      },
      StoresType:'',
      personShow1:false,
      personShow:false,
      userparm: [], //搜索权限
      listData: [], //用户数据
      ListPreAboutForms:[],
          WZYGName:'',
    WZHYName:'',
    WZXMName:'',
    WZPBName:'',
    dateType:'',

    siteShow:false,
      q4:false,
      q5:false,
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      },
           iscz:0,
       flag: false, // 滚动标识，防止改变scrollLeft时重复触发scroll事件
      proportion: 1 // 设置默认比例为1

    }
  },
  // 注册组件
  components: {
    Pagination,
     CropperImage,
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.WZYGName = localStorage.getItem('WZYGName')
    this.WZHYName = localStorage.getItem('WZHYName')
    this.WZXMName = localStorage.getItem('WZXMName')
    this.WZPBName = localStorage.getItem('WZPBName')
         if(localStorage.getItem('isAdmin') == 1){
          this.q1 = true
          this.q2 = true
          this.q3 = true
          this.q4 = true
          this.q5 = true
          this.q11 = true
         
      }
      this.StoresType =localStorage.getItem('StoresType')
      this.Limits = localStorage.getItem('Limits')
      this.Limits = this.Limits.split(',')
      this.Limits.forEach(items => {
          if(items == 72){
            this.q1 = true
          }
          if(items == 73){
            this.q2 = true
          }
          if(items == 74){
            this.q3 = true
          }
          if(items == 75){
            this.q4 = true
          }
          if(items == 76){
            this.q5 = true
          }
          if(items == 77){
            this.q11 = true
          }
         
   })
      // this.getList()
    
    var date = new Date();
    var year = date.getFullYear(); //获取完整的年份(4位)
   var mounth = date.getMonth() + 1; //获取当前月份(0-11,0代表1月)
    var day =   date.getDate(); //获取当前日(1-31)
    this.date = year + '-' + mounth + '-' + day
    if(mounth<10)
      mounth = '0' +  mounth
    if(day<10)
      day = '0' +  day
    this.today = year + '-' + mounth + '-' + day
    console.log(this.today)

    this.getDianList()
    this.getRowClassTimsqt()
    this.getPersonList()
    this.formInline = {
            page: 1,
            limit:1000,

        }
    this.getProjectList()
    this.getSiteList()
    this.getList()
    this.getRowType()
    this.getperList()
    //   var myDate = new Date();
    //   if(myDate.getHours() <10){
    //     var hour = '0' + myDate.getHours() 
    //   } else {
    //     var hour =  myDate.getHours() 
    //   }
    //   if(myDate.getMinutes()<10){
    //     var minute = '0' + myDate.getMinutes()
    //   } else {
    //     var minute =  myDate.getMinutes()
    //   }
    //   var time = hour + ':' + minute
         
    //   //  console.log(time)
    //    for( var i = 0;i<this.timeData.length;i++){
    //       if(time < this.timeData[i].startTime)
    //         {
    //           var t = i 
    //           break
    //         }
    //    }

    // this.$nextTick(()=>{
    // var loading = this.$loading({
    //       lock: true,
    //       text: '加载中...',
    //       spinner: 'el-icon-loading',
    //       background: 'rgba(0, 0, 0, 0.7)'
    //     });
    
    //    this.$refs.list1.forEach((item,index)=>{
    //     if(index  == t){
    //        this.cd = false
    //       item.scrollIntoView({ behavior: "auto",block: "start",inline:'center'})
    //           loading.close()
    //     }
     
     
    //   })
    //   loading.close()
    // })

  },
   mounted() {
    // 用内容宽度减去容器宽度
    

  },



methods: {
         saveImage(divText, imgText) {
            let canvasID = this.$refs[divText];
            let that = this;
            let a = document.createElement('a');

        let imgHeight = window.document.querySelector('.html2canvas').offsetHeight // 获取DOM高度
        let imgWidth = window.document.querySelector('.html2canvas').offsetWidth // 获取DOM宽度
          let scale = window.devicePixelRatio // 获取设备像素比

        alert(imgHeight)
        alert(imgWidth)
        alert(scale)

             const options = {
                 allowTaint: true,
                  backgroundColor: null,
                  useCORS: true,
                  scale: scale,
            width: imgWidth,
            height: imgHeight
               

            }
            html2canvas(canvasID,options).then(canvas => {
                let dom = document.body.appendChild(canvas);
                dom.style.display = 'none';
                a.style.display = 'none';
                document.body.removeChild(dom);
                let blob = that.dataURLToBlob(dom.toDataURL('image/png'));
                a.setAttribute('href', URL.createObjectURL(blob));
                //这块是保存图片操作  可以设置保存的图片的信息
                a.setAttribute('download', imgText + '.png');
                document.body.appendChild(a);
                a.click();
                URL.revokeObjectURL(blob);
                document.body.removeChild(a);
            });
        },
               dataURLToBlob(dataurl) {
            let arr = dataurl.split(',');
            let mime = arr[0].match(/:(.*?);/)[1];
            let bstr = atob(arr[1]);
            let n = bstr.length;
            let u8arr = new Uint8Array(n);
            while (n--) {
                u8arr[n] = bstr.charCodeAt(n);
            }
            return new Blob([u8arr], { type: mime });
        },
handlesheng1(){
  
      var date = new Date(this.date) 
      let weekFirstDay = new Date(date - (date.getDay() - 1) * 86400000)
      let firstMonth = Number(weekFirstDay.getMonth()) + 1

      if (firstMonth < 10) {
      firstMonth = '0' + firstMonth
      }
      let weekFirstDays = weekFirstDay.getDate();
      if (weekFirstDays < 10) {
        weekFirstDays = '0' + weekFirstDays;
      }
     var  date1 = weekFirstDay.getFullYear() + '-' + firstMonth + '-' + weekFirstDays;
      
        let weekFirstDay1 = new Date(date - (date.getDay() - 1) * 86400000)
        let weekLastDay = new Date((weekFirstDay1 / 1000 + 6 * 86400) * 1000)
        let lastMonth = Number(weekLastDay.getMonth()) + 1
        if (lastMonth < 10) {
        lastMonth = '0' + lastMonth
        }
        let weekLastDays = weekLastDay.getDate();
        if (weekLastDays < 10) {
        weekLastDays = '0' + weekLastDays;
        }
        var date2 = weekFirstDay1.getFullYear() + '-' + lastMonth + '-' + weekLastDays;


      // return weekFirstDay.getFullYear() + '-' + firstMonth + '-' + weekFirstDays;
      


        var loading = this.$loading({
          lock: true,
          text: '加载中...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
                this.date
                var data = {}
                data.token=localStorage.getItem("token")
                data.StoresID=localStorage.getItem("StoresID")
                data.SelectStoresID  = this.SelectStoresID

                if(this.LoginID === ''){
                      var id = -1
                    } else {
                      var id = this.LoginID
                }
                data.SKtime1 = date1
                data.SKtime2= date2
                data.objID= this.objID
                data.LoginIDs= id 
                data.Site= this.Site
                data.RowType = this.RowType
                var that = this
                this.ajax('getRowClassImg.aspx',JSON.stringify(data),"POST",function(res){
                    if (res.orsuccess == "1") {
                        loading.close()
                       const url = res.data // 完整的url则直接使用
                      
                          fetch(url).then(res => res.blob()).then(blob => { // 将链接地址字符内容转变成blob地址
                                let elink = document.createElement("a");
                                      elink.download = '课表.png';
                                      elink.style.display = "none";
                                      elink.href = URL.createObjectURL(blob);
                                      document.body.appendChild(elink);
                                      elink.click();
                                      URL.revokeObjectURL(elink.href); // 释放URL 对象
                                      document.body.removeChild(elink);
                          })
                            
                     } else {
                       loading.close()
                     }

                })

  },
  handlesheng(){
  var loading = this.$loading({
          lock: true,
          text: '加载中...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });

                var data = {}
                data.token=localStorage.getItem("token")
                data.StoresID=localStorage.getItem("StoresID")
                data.SelectStoresID  = this.SelectStoresID
          //                 FirstDay:this.timeData[0].Stime,
          // LastDay:this.timeData[6].Stime,
          // objID:this.objID,
          // Site:this.Site,
          // LoginID: id,
          // RowType:this.RowType,
                if(this.LoginID === ''){
                      var id = -1
                    } else {
                      var id = this.LoginID
                }
                data.SKtime1 =this.timeData[0].Stime
                data.SKtime2= this.timeData[6].Stime
                data.objID= this.objID
                data.LoginIDs= id 
                data.Site= this.Site
                data.RowType = this.RowType
                var that = this
                this.ajax('getRowClassImg.aspx',JSON.stringify(data),"POST",function(res){
                    if (res.orsuccess == "1") {
                        loading.close()
                       const url = res.data // 完整的url则直接使用
                      
                          fetch(url).then(res => res.blob()).then(blob => { // 将链接地址字符内容转变成blob地址
                                let elink = document.createElement("a");
                                      elink.download = '课表.png';
                                      elink.style.display = "none";
                                      elink.href = URL.createObjectURL(blob);
                                      document.body.appendChild(elink);
                                      elink.click();
                                      URL.revokeObjectURL(elink.href); // 释放URL 对象
                                      document.body.removeChild(elink);
                          })
                            
                     } else {
                       loading.close()
                     }

                })

  },
  
    deleteUser1(row){
        this.$confirm("确定要删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
         var data = { SelectStoresID:this.SelectStoresID,
          StoresID:localStorage.getItem("StoresID"),
          token: localStorage.getItem("token"),
             SiteID:row.ID,
        
        }
        var that = this
        this.ajax('delSite.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
              that.$message({
                type: "success",
                message: "删除成功",duration:2000,
              });
        
              that.getSiteList()
              //  that.provinceList = res.data
            }

        })
        })
        .catch(() => {
            ;
        });
   
    },
      submitForm1(editData) {

      this.$refs[editData].validate(valid => {
        if (valid) {
            var data = this.editForm1
                data.token=localStorage.getItem("token")
                data.StoresID=localStorage.getItem("StoresID")
                data.SelectStoresID  = this.SelectStoresID
                var that = this
            if(this.title1 == '添加'){
                this.ajax('addSite.aspx',JSON.stringify(data),"POST",function(res){
                    if (res.orsuccess == "1") {
                        that.$message({
                            type: "success",
                            message: "新建成功",duration:2000,
                        });
                        that.editFormVisible1 = false
                        that.getSiteList()
                     }

                })

            }else {
                data.SiteID =  this.editForm1.ID
                 this.ajax('editSite.aspx',JSON.stringify(data),"POST",function(res){
                    if (res.orsuccess == "1") {
                        that.$message({
                            type: "success",
                            message: "修改成功",duration:2000,
                        });
                        that.editFormVisible1 = false
                        that.getSiteList()
                     }

                })
            }
        } else {
          return false
        }
      })
    },
      handleEdit1(row){
          if (row != undefined && row != 'undefined') {
              this.title1 = '编辑'
       
              this.editForm1 = row
           
    
          } else {
              this.title1 = '添加'
                this.editForm1 = {
                  SiteName:''
                }
          }
          this.editFormVisible1 = true
    },
  toPerson1(){
     this.personShow1 = true
  },
  changeDateType(){
    this.editForm.startTime = ''
    this.editForm.endTime = ''
    this.checkedCycles = []
  },
  toyincang(items){
    if(items.Isshow == 1){
      this.$confirm("确定要隐藏吗?", "提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
            })
            .then(() => {
              var data = { 
                SelectStoresID:this.SelectStoresID,
                StoresID:localStorage.getItem("StoresID"),
                token: localStorage.getItem("token"),
                RowClassID:items.RowClassID,
                Isshow:0
              }
              var that = this
              this.ajax('editRowClassIsshow.aspx',JSON.stringify(data),"POST",function(res){

                if (res.orsuccess == "1") {

                    that.$message({
                      type: "success",
                      message: "隐藏成功",duration:2000,
                    });

                    that.getList()
                  
                  }

              })
              })
              .catch(() => {
                  ;
              });
    } else {
      this.$confirm("确定要展示吗?", "提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
            })
            .then(() => {
              var data = { 
                SelectStoresID:this.SelectStoresID,
                StoresID:localStorage.getItem("StoresID"),
                token: localStorage.getItem("token"),
                RowClassID:items.RowClassID,
                Isshow:1
              }
              var that = this
              this.ajax('editRowClassIsshow.aspx',JSON.stringify(data),"POST",function(res){

                if (res.orsuccess == "1") {
                    that.$message({
                      type: "success",
                      message: "展示成功",duration:2000,
                    });
              
                    that.getList()
                  
                  }

              })
              })
              .catch(() => {
                  ;
              });
    }

  },
  toSite(){

    this.siteShow = true

  },
  handleDel(){

     this.$router.push({
        path:`/arrange/delLesson/${this.SelectStoresID}`
      })

  },
  toCopy(ids){
      const loading = this.$loading({
          lock: true,
          text: '加载中...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        
      if(this.LoginID === ''){
        var id = -1
      } else {
        var id = this.LoginID
      }

     var data = { 
          SelectStoresID:this.SelectStoresID,        
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
          FirstDay:this.timeData[0].Stime,
          LastDay:this.timeData[6].Stime,
          objID:this.objID,
          Site:this.Site,
          LoginID: id,
          RowType:this.RowType,
          isCopy:ids
      }
   setTimeout(() => {
      var that = this
      this.ajax('CopyWeekRowClass.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
         that.$message({
                type: "success",
                message: "复制成功",duration:2000,
              });
              that.copyShow = false
              that.getWeeks()
     
          } 
       })
         loading.close()
   }, 1000);
  },
  handlefu(){
    this.copyShow = true
    this.getCopyRowClass()
  },
  getCopyRowClass(){
          if(this.LoginID === ''){
        var id = -1
      } else {
        var id = this.LoginID
      }
      var data = { 
          SelectStoresID:this.SelectStoresID,        
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
          FirstDay:this.timeData[0].Stime,
          LastDay:this.timeData[6].Stime,
          objID:this.objID,
          Site:this.Site,
          LoginID:this.id,
          RowType:this.RowType,
      }
  
      var that = this
      this.ajax('CompareCopyRowClass.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
         
                that.isCopy = res.isCopy
    
          } 
       })
  },
  getperList(){
      var data = { 
          SelectStoresID:this.SelectStoresID,        
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
          pages:1,
          psize:1000
      }
  
      var that = this
      this.ajax('getlistStaffpb.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
                
                that.perList= res.data
                if(localStorage.getItem("Iswyg") == 1){
                  var list = {
                    Name:'无'+that.WZYGName,
                    ID:0,
                  }
                  that.perList.push(list)
                }
                 
          } 
       })
  },
  getRowType(){
       var data = { 
          SelectStoresID:this.SelectStoresID,        
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
      }
  
      var that = this
      this.ajax('getListRowTypeSetting.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
         
                that.RowTypeList= res.data

          } 
       })
    },
  changeTime(){
    // this.editForm.startTime
    if(this.editForm.startTime && this.editForm.endTime){
      if(this.editForm.startTime>this.editForm.endTime){
         this.$message({    
                message: "开始日期不得小于结束日期",
          });

      } else {
          var day1 = new Date(this.editForm.startTime);
          var day2 = new Date(this.editForm.endTime);
          var day = (day2 - day1) / (1000 * 60 * 60 * 24) + 1
          if(day>31){
            this.$message({    
                message: "最多只能排31天",
          });
          }

      }
      
    }
    console.log(this.editForm.startTime)
    console.log( this.editForm.endTime)
  },
  changeType(){

   
      if(this.type == 1){
        this.cd = false
          this.getList()
          // this.isweek  = 0
      } else {
          this.$refs.nav.scrollLeft =0 
          this.$refs.externalForm.scrollLeft = 0
          this.cd = false
          this.isweek  = 0
          this.getList()
        
      }
  },

  getWeeks(){
          if(this.LoginID === ''){
        var id = -1
      } else {
        var id = this.LoginID
      }
    var data = { 
              SelectStoresID:this.SelectStoresID,
              token: localStorage.getItem("token"),
              StoresID:localStorage.getItem("StoresID"),
              SKtime:this.date,
              objID:this.objID,
              Site:this.Site,
              LoginID:id,
              isweek:this.isweek,
              RowType:this.RowType,
              
        }
        
          var that = this
      if(this.chooseTrue == true){
        this.ajax('getListRowClassWeeks.aspx',JSON.stringify(data),"POST",function(res){
            if (res.orsuccess == "1") {
                  that.tableLoading = false
                  that.timeData = res.data
                  that.list = res.terList
            } 

        })
      } else {
        this.ajax('getListRowClassProjectWeeks.aspx',JSON.stringify(data),"POST",function(res){
            if (res.orsuccess == "1") {
                  that.tableLoading = false
                  that.timeData = res.data
                  that.list = res.ProjectList
                  console.log(that.list)
            } 

        })
      }
      this.$loading().close()
  },
  changeRow(){
    console.log(this.editForm.RowType)
      if(this.editForm.RowType == 1){
          this.editForm.RowClassTypeqt = '2'
      }
  },
 changeFlag(flag) {
    this.flag = flag
  },
  // 左右滚动条滚动同步
  sysHandleScroll() {
    if (!this.flag) {
      this.$refs.externalForm.scrollTop = this.$refs.systemForm.scrollTop
    }
  },

  exterHandleScroll() {
    // console.log('1111')
    // var css = this.$refs.externalForm.scrollLeft
    if (this.flag) {
      this.cd = true
       this.$refs.nav.scrollLeft = this.$refs.externalForm.scrollLeft
       this.$refs.systemForm.scrollTop = this.$refs.externalForm.scrollTop
    }
  
  },


   

  //   handleScroll() {
  //       console.log('11111')
  //  let h = $(this.$refs.header).outerHeight(); //header的高度
  //  let wh = $(window).scrollTop(); //滚动的距离的，为什么这里使用的jq，因为不用考虑的什么的兼容问题
  //  let navH = $(this.$refs.nav).outerHeight(); //nav的高度
  
  //  if (wh > h) {
  //   this.isFixed = true;
  //  } else {
  //   this.isFixed = false;
  //  }
  // },
    todelet(items){
      console.log(items)
     this.$confirm("确定要删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
         var data = { SelectStoresID:this.SelectStoresID,
          StoresID:localStorage.getItem("StoresID"),
          token: localStorage.getItem("token"),
            RowClassID:items.RowClassID,
        
        }
        var that = this
        this.ajax('delRowClass.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
              that.$message({
                type: "success",
                message: "删除成功",duration:2000,
              });
        
              that.getList()
              //  that.provinceList = res.data
            }

        })
        })
        .catch(() => {
            ;
        });
   
    },
    toEdit(items){
      this.title = '修改'
      console.log(items)

      this.personName = items.terName
      var data = { 
          SelectStoresID:this.SelectStoresID,
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
          RowClassID:items.RowClassID
      }
  
        var that = this
      this.ajax('getRowClassInfo.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
                that.editForm = res.data
                that.isEditqt = true
                that.iscx = that.editForm.iscx
                that.isck = that.editForm.isck
                that.editFormSure()
                // that.editForm.RowType = res.data.RowType
                // that.editShow = true
          } 

      })


    },
    editFormSure(){
      this.editForm.isPreAboutInfo = Number(this.editForm.isPreAboutInfo)
      this.projectList.forEach(items => {
          if(items.ID == this.editForm.objID){
            this.objitems = items
            this.editForm.objID = items.ID
          }
        
      });
      this.iscz = 0
      this.editShow = true
      if(this.editForm.isPreAboutInfo == 1){
                this.getPreAboutInfo()
        } else {
           this.editForm.ListPreAboutForms = []
        }
 
        if(this.editForm.RowClassTypeqt=='2'){
          this.getListRowClassTime();
              
              } else {
          this.getListRowClassTimeQT();
        }
                   
    },

getListRowClassTime(){
 var data = { 
          SelectStoresID:this.SelectStoresID,        
          StoresID:localStorage.getItem("StoresID"),
          token: localStorage.getItem("token"),
          objType:2,
          RowClassID:this.editForm.ID
          // objID:this.editForm.ID
        }
        var that = this
        this.ajax('getListRowClassTime.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
               that.listRowClassTime  = res.data
              that.Copytimes();
              // that.editForm.ListPreAboutForms = res.data
      
              //  that.provinceList = res.data
            }

        })
},
Copytimes(){
  let arr =[]
   this.listRowClassTime.forEach(items => {
              arr.push(items);
           });
           this.listRowClassTimeCopy =arr
},
getListRowClassTimeQT(){
  var data = { 
          SelectStoresID:this.SelectStoresID,        
          StoresID:localStorage.getItem("StoresID"),
          token: localStorage.getItem("token"),
          objType:2,
          RowClassID:this.editForm.ID
          // objID:this.editForm.ID
        }
        var that = this
        this.ajax('getListRowClassTimeQT.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
                that.listRowClassTimeQT = res.data
           
              // that.editForm.ListPreAboutForms = res.data
      
              //  that.provinceList = res.data
            }

        })
},
getPreAboutInfo(){
    var data = { 
          SelectStoresID:this.SelectStoresID,        
          StoresID:localStorage.getItem("StoresID"),
          token: localStorage.getItem("token"),
          objType:'2',
          objID:this.editForm.ID
        }
        var that = this
        this.ajax('getListPreAboutForms.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
              that.editForm.ListPreAboutForms = res.data
      
              //  that.provinceList = res.data
            }

        })
  
},


    toqiehuan(){
      this.chooseTrue  =!this.chooseTrue
      this.getList()
    },
    getSiteList(){
       var data = { 
        SelectStoresID:this.SelectStoresID,
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
          pages:1,
          psize:200,

      }
  
        var that = this
      this.ajax('getListSite.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
            
                that.siteList = res.data
      
          } 

      })
    },handleXiu(index,row) {
      this.TimeInfo=row;
      this.limitCountCopy=row.limitCount;
      this.MinCountCopy=row.MinCount;
      
      this.timeindex=index;
      this.editFormTimeVisible =true;
    },submitFormTimecoles(){
      this.TimeInfo.MinCount = this.MinCountCopy;
      this.TimeInfo.limitCount = this.limitCountCopy;

      this.editFormTimeVisible =false;

    },submitFormTime(){

      if(this.TimeInfo.ID >0){
       
        this.TimeInfo.state="2";
      } 
 
       this.$set(this.listRowClassTime, this.timeindex, this.TimeInfo)
       if(this.title=='修改'){
       this.$set(this.listRowClassTimeCopy, this.timeindex, this.TimeInfo)
      }
       this.editFormTimeVisible =false;

    },
      deleteRow(index, rows,row) {

        
        if(this.title=='修改'){
          this.listRowClassTimeCopy.forEach(items => {
               if(items.ID >0 && items.ID == row.ID){
                  items.state="3";
               }
           });
        }
         
        rows.splice(index, 1);
      },
    addRowClassTimeClick1(){
             
        var startTime = this.startTimenew;
        var endTime = this.RowClasendTime;
        var limitCount = this.limitCount
        var MinCount = this.MinCount 
        var  flag = false
        this.listRowClassTime.forEach(items => {
          if(startTime == items.startTime){
              this.$message({
                duration:2000,
                message:'时间不允许重复'
              });
             flag = true
            }
          });
            if(flag == false){
                if(this.isEdit){
                            this.listRowClassTime.push({
                                ID:"0",
                                RowClassID:this.CurriculumnID,
                                startTime:startTime,
                                endTime:endTime,
                                timeTpey:"1",
                                MinCount:MinCount,
                                limitCount:limitCount,
                                MembersID:"0",
                                state:"1",
                            })
                            this.listRowClassTimeCopy.push({
                                ID:"0",
                                RowClassID:this.CurriculumnID,
                                startTime:startTime,
                                endTime:endTime,
                                timeTpey:"1",
                                MinCount:MinCount,
                                limitCount:limitCount,
                                MembersID:"0",
                                state:"1",
                            })
                        }else{
                            this.listRowClassTime.push({
                                ID:"0",
                                RowClassID:0,
                                startTime:startTime,
                                endTime:endTime,
                                MinCount:MinCount,
                                limitCount:limitCount,
                                timeTpey:"1",
                                MembersID:"0",
                                state:"1",
                            })
                             this.listRowClassTimeCopy.push({
                                ID:"0",
                                RowClassID:0,
                                startTime:startTime,
                                endTime:endTime,
                                MinCount:MinCount,
                                limitCount:limitCount,
                                timeTpey:"1",
                                MembersID:"0",
                                state:"1",
                            })
                        }
                        
            }
        },
    RowClassTimeClick(){
                this.startTimenew ="08:00";
                this.PeriodOfTime = "1";
                this.editForm.shour="08";
                 this.editForm.sminute="00";
                 this.changeshour1();
                 this.MinCount=1;
                 this.limitCount=1;
                this.RowClassTimeShow = true;
      },
        forceUpdate () { 
    this.$forceUpdate() 
  },
             changeshour1(val){
  
                let th =this.editForm.Timelength;
               if(th==''){

                   th =0;
               }
                   var Timelength = parseInt(th)  

                       var hour = parseInt(this.editForm.shour);
                       var min = parseInt(this.editForm.sminute);
                       this.startTimenew = this.editForm.shour+":"+this.editForm.sminute;
                       var times = min+Timelength;
                 
                       if(times>=60){
                           var hs = parseInt(times/60);
                           hour = hour+hs;
                           times = times -60 * hs;
                       }
                        if(hour>=24){
                            hour=hour -24;
                        }
                        if(hour==24){
                            hour ="00";
                        }else if(hour<10){
                          hour = '0'+hour;
                        }
                        
                        
                        if(times==0){
                            times = '00';
                         }else if(times<10){
                         times = '0'+times;
                         }

                     this.RowClasendTime =hour+":"+times;
            },
            changesminute1(val){
                let th =this.editForm.Timelength;
               if(th==''){

                   th =0;
               }
                var Timelength = parseInt(th)  

                         var hour = parseInt(this.editForm.shour);
                       var min = parseInt(this.editForm.sminute);

                       this.startTimenew = this.editForm.shour+":"+this.editForm.sminute;

                       var times = min+Timelength;
                 
                       if(times>=60){
                           var hs = parseInt(times/60);
                           hour = hour+hs;
                           times = times -60 * hs;
                       }
                        if(hour>=24){
                            hour=hour -24;
                        }
                        if(hour==24){
                            hour ="00";
                        }else if(hour<10){
                          hour = '0'+hour;
                        }
                       
                        if(times==0){
                            times = '00';
                         }else if(times<10){
                         times = '0'+times;
                         }


                      this.RowClasendTime =hour+":"+times;
            },
      deleteRowClassTimeqt(row,index){

        this.listRowClassTimeQT.splice(this.listRowClassTimeQT.indexOf(row),1)

    },
    RowClassTimeqzClick(){
                if(this.title !='修改'){
                    this.$confirm('确定重置吗，一旦重置将会清空所有预约数据。', '提示', {
                         confirmButtonText: '确定',
                         cancelButtonText: '取消',
                         type: 'warning'
                     }).then(() => {
                      
                         this.getRowClassTimsqt();
                 }).catch(() => {
                    
                });
                }else{
               
                    this.getRowClassTimsqt();
                }           
                 },
      tochooseObj(){
        this.objShow = true
        this.formInline = {
            page: 1,
            limit:10,

        }
        this.getProjectList()
    },
      sureProject(items){
          this.objitems = items
          this.editForm.objID = items.ID
          this.editForm.RowTypeID = items.RowTypeID
          this.editForm.Timelength = items.Timelength
          this.editForm.objAmount =items.Amount
          this.editForm.RowType = items.RowType
          this.editForm.RowTypeName = items.RowTypeName
          this.editForm.xhAmount = items.Amount

          this.editForm.iscx = items.iscx.toString() 
          this.editForm.isck = items.isck.toString() 
          this.iscx = items.iscx
          this.isck = items.isck
          this.objShow = false
          if( this.editForm.RowType == 1){
              this.editForm.RowClassTypeqt = '2'
          } else {
             this.editForm.RowClassTypeqt = '1'
          }
         
         
        
      },
    changeOptions1(val){
        
                   if( val=='2'){
                this.$confirm('确定切换模式，一旦切换将会清空所有预约数据。', '提示', {
                         confirmButtonText: '确定',
                         cancelButtonText: '取消',
                         type: 'warning'
                     }).then(() => {
                         
                         this.listRowClassTime=[];
                  }).catch(() => {
                    
                });
                   }
                    if( val=='1'){
                      this.$confirm('确定切换模式，一旦切换将会清空所有预约数据。', '提示', {
                         confirmButtonText: '确定',
                         cancelButtonText: '取消',
                         type: 'warning'
                     }).then(() => {
                        this.editForm.Timelengthqt = 30
                          this.getRowClassTimsqt();
                  }).catch(() => {
                    
                });
                   }

            },
      surePerson(){
          this.LoginIDs = []
          for(var i = 0;i<this.personList.length;i++){
              var items = this.personList[i].listsub
              for(var j = 0; j<items.length;j++){
                  if(items[j].show)
                  {
                      var list = {
                          name:items[j].Name,
                          ID:items[j].ID
                      }
                    this.LoginIDs.push(list)
                  }
                  
              }
          }
          console.log(this.LoginIDs)
          this.personShow = false
      },
      choose(items){
        if(this.title == '修改'){
          this.personName = items.Name
          this.editForm.LoginIDs = items.ID
          console.log(items)
          this.personShow1 = false
        } else {
           if(items.show){
              items.show = false
          } else {
              items.show = true
          }
           this.thier =  new Date().getTime()
        }
         
      },
    toPerson(){
        this.personShow = true
    },
      save(){
 var list = Array.from(this.ListPreAboutForms)
      var  cd = false
      list.forEach(items => {
        if(items.Title == ''){
            cd = true
          
        }
      });
      if(cd == true){
          this.$message({
              duration:2000,
              message:'请输入标题'
          });
      } else {
          this.preShow = false
          this.editForm.ListPreAboutForms =  Array.from(this.ListPreAboutForms)
            console.log( this.editForm.ListPreAboutForms)
            for(var i = 0 ;i<this.editForm.ListPreAboutForms.length;i ++){
                this.editForm.ListPreAboutForms[i].sort = i       
          }
      }
      
     
    },
     dragstart(value) {
            this.oldData = value
        },

        // 记录移动过程中信息
        dragenter(value, e) {
            this.newData = value
            e.preventDefault()
        },

        // 拖拽最终操作
        dragend(value, e) {
            if (this.oldData !== this.newData) {
                let oldIndex = this.ListPreAboutForms.indexOf(this.oldData)
                let newIndex = this.ListPreAboutForms.indexOf(this.newData)
                let newItems = [...this.ListPreAboutForms]
                // 删除老的节点
                newItems.splice(oldIndex, 1)
                // 在列表中目标位置增加新的节点
                newItems.splice(newIndex, 0, this.oldData)
                this.ListPreAboutForms = [...newItems]
            }
        },


        // 拖动事件（主要是为了拖动时鼠标光标不变为禁止）
        dragover(e) {
            e.preventDefault()
        },

    todel(items,index){
      if(this.title == this.WZPBName){
        this.ListPreAboutForms.splice(index, 1)
      } else {
      this.timer =  new Date().getTime()
        items.state = 3
      }
       
    },
    toadd(type){
        var list = {
          length:this.ListPreAboutForms.length,
          Title:'',
          fType:type,
          objID:this.editForm.ID,
          isbt:'1',
          state:1,
          objType:'2'   
        }
      console.log(this.ListPreAboutForms)
      this.ListPreAboutForms.push(list)      
 
    },
    hover(items){
      items.show = true
      this.timer =  new Date().getTime()
      console.log(items.show)
      // console.log('1111')
    },
    UpRoll(items){
      items.show = false
      this.timer =  new Date().getTime()
 
        console.log(items.show)    
    },


     openPreAbout(){
      if(this.title != this.WZPBName){
            for(var i= 0;i<this.editForm.ListPreAboutForms.length;i++ ){
                this.editForm.ListPreAboutForms[i].length = i
                this.editForm.ListPreAboutForms[i].state = 0
            }
      }
      this.ListPreAboutForms = this.editForm.ListPreAboutForms
      this.preShow = true
    },
      getProjectList(){
        var data = { 
            SelectStoresID:this.SelectStoresID,        
            token: localStorage.getItem("token"),
            StoresID:localStorage.getItem("StoresID"),
            pages:this.formInline.page,
            psize:this.formInline.limit,
            ProjectTypeID:0
          // StaffTypeID:this.active
      }

      
        var that = this
      this.ajax('getListProject.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
                that.projectList =[];
                that.projectList = res.data
                that.pageparm.total = res.allcount

          } 

      })
      },
      getPersonList(){
           var data = { 
            SelectStoresID:this.SelectStoresID,
            token: localStorage.getItem("token"),
            StoresID:localStorage.getItem("StoresID")
         }
        var that = this
       this.ajax('getlistStaffglpb.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
               that.personList = res.data
               
            }

      })
      },
    handleChange(val,item){
                // console.log(val)
                this.editForm.Cycle = val.join();
                // console.log(this.editForm.Cycle)
    },
    getRowClassTimsqt(){
      if(this.title == '修改'){
          this.$confirm('确定修改吗，一旦重置将会清空所有预约数据。', '提示', {
                         confirmButtonText: '确定',
                         cancelButtonText: '取消',
                         type: 'warning'
                     }).then(() => {
                        this.iscz = 1
                                var data = { 
                    SelectStoresID:this.SelectStoresID,
                  token: localStorage.getItem("token"),
                  StoresID:localStorage.getItem("StoresID"),
                Timelengthqt:this.editForm.Timelengthqt
              }
                var that = this
              this.ajax('getRowClassTimsqt.aspx',JSON.stringify(data),"POST",function(res){

                  if (res.orsuccess == "1") {
                      that.listRowClassTimeQT = res.data
                      that.isEditqt = false
                    }

              })
                        
                 }).catch(() => {
                    

                });
      



      } else {
        var data = { 
                SelectStoresID:this.SelectStoresID,
                token: localStorage.getItem("token"),
                StoresID:localStorage.getItem("StoresID"),
                Timelengthqt:this.editForm.Timelengthqt
              }
        var that = this
              this.ajax('getRowClassTimsqt.aspx',JSON.stringify(data),"POST",function(res){

                  if (res.orsuccess == "1") {
                      that.listRowClassTimeQT = res.data
                      that.isEditqt = false
                    }

              })
              }
        
    },
    toToady(){
        var date = new Date();
        var year = date.getFullYear();
	     	var month =  date.getMonth()+1;
	    	var day=  date.getDate();
        this.date = year + '-' + month + '-' + day
        this.isweek = 0
        this.getList()
        
    },
    toYesterDay(){
      this.$refs.nav.scrollLeft =0 
      this.$refs.externalForm.scrollLeft = 0
      if(this.type == 1){
                var date = new Date(this.date);//比如sourceDate传参“2019-03-31”
            date.setDate(date.getDate() -1);
            var year=date.getFullYear();
	     	var month=  date.getMonth()+1;
	    	var day=date.getDate();
           this.date = year+"-"+month+"-"+day;
           
      } else {
         this.date = this.timeData[0].Stime
        this.isweek = 1
      }
      this.getList()
    },
    toTomorrow(){
                        this.$refs.nav.scrollLeft =0 
            this.$refs.externalForm.scrollLeft = 0
      if(this.type == 1){
            var date = new Date(this.date);//比如sourceDate传参“2019-03-31”
            date.setDate(date.getDate() + 1);
            var year=date.getFullYear();
	     	var month= date.getMonth()+1;
	    	var day= date.getDate();
           this.date = year+"-"+month+"-"+day;
         
      } else {
        this.date = this.timeData[6].Stime
        this.isweek = 2
      }
            this.getList()
    },
    changeDate(){
      this.getList()
    },
    getDianList(){
       var data = { 
         SelectStoresID:localStorage.getItem("StoresID"),
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID")
      }
        var that = this
       this.ajax('getListStores.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
               that.DianList =res.data
            }

      })
    },

    changedian(){

     this.getRowClassTimsqt()
      this.getPersonList()
      this.getProjectList()
      this.getSiteList()
      this.getList()
      this.getRowType()
      this.getperList()

      

    },
    deleteUser(row){
        this.$confirm("确定要删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
         var data = { SelectStoresID:this.SelectStoresID,
          StoresID:localStorage.getItem("StoresID"),
          token: localStorage.getItem("token"),
             SiteID:row.ID,
        
        }
        var that = this
        this.ajax('delSite.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
              that.$message({
                type: "success",
                message: "删除成功",duration:2000,
              });
        
              that.getList()
              //  that.provinceList = res.data
            }

        })
        })
        .catch(() => {
            ;
        });
   
    },


    handlePassword(){
        this.quanxian = true
    },
    handleEdit(row){

              this.title = this.WZPBName
              this.objitems = {}
              this.checkedCycles = []
              this.LoginIDs = []
              this.ListPreAboutForms = []
              this.listRowClassTime = []
              this.isck = 0
              this.iscx = 0
              this.dateType = '1'
              this.getPersonList()
              this.editForm = {
                RowType:'',
                shour:'',
                sminute:'',
                RowClassType:1,
                SiteName:'',
                isPreAboutInfo:0,
                ListPreAboutForms:[],
                RowType:'',
                ListRowClassTime:" ",
                LoginIDs:'',
                Timelength:'',
                startTime:'',
                endTime:'',
                objID:'',
                RowClassTypeqt:'1',
                xhAmount:0,
                payPrice:0,
                iscx:'0',
                isck:'0',
                xhnumber:0,
                Timelengthqt:30,
                ismincount:'0',
                integral:0,
                IsPay:'0',
                PreAboutType:'1',
          }
              

          this.editFormVisible = true
    },
    handleCheckChange(data, checked, indeterminate) {
        console.log(data, checked, indeterminate);
         console.log(this.$refs.tree.getCheckedNodes());
      },

    search() {
      
      this.getList()
      // this.getdata(this.formInline)
    },
    getDayList(){
         
      if(this.LoginID === ''){
        var id = -1
        } else {
          var id = this.LoginID
        }
         var data = { 
            SelectStoresID:this.SelectStoresID,
            token: localStorage.getItem("token"),
            StoresID:localStorage.getItem("StoresID"),
            SKtime:this.date,
            objID:this.objID,
            Site:this.Site,
            LoginID:id,
            RowType:this.RowType,
      }
      
        var that = this
    if(this.chooseTrue == true){
       this.ajax('getListRowClass.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
                that.tableLoading = false
                that.timeData = res.data
                that.list = res.terList
                
             
          } 

      })
    } else {
      this.ajax('getListRowClassProject.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
                that.tableLoading = false
                that.timeData = res.data
                that.list = res.ProjectList
                console.log(that.list)
            
          } 

      })
      }
    this.cd = false
     var date = new Date();
        var year = date.getFullYear();
	     	var month =  date.getMonth()+1;
	    	var day = date.getDate();
      var   today =  year + '-' + month + '-' + day
    //  console.log('111111',this.date)
    //   console.log('111111',today)
      if(this.date == today ){
        var myDate = new Date();
          if(myDate.getHours() <10){
        var hour = '0' + myDate.getHours() 
         } else {
        var hour =  myDate.getHours() 
        }
        if(myDate.getMinutes()<10){
        var minute = '0' + myDate.getMinutes()
        } else {
        var minute =  myDate.getMinutes()
        }
        var time = hour + ':' + minute
         
      //  console.log(time)
      for( var i = 0;i<this.timeData.length;i++){
          if(time < this.timeData[i].startTime)
            {
              var t = i 
              break
            }
      }
     this.$nextTick(()=>{
     

       this.$refs.list1.forEach((item,index)=>{
        if(index  == t){
            // this.cd = true
          item.scrollIntoView({ behavior: "auto",block: "start",inline:'center'})
          this.exterHandleScroll()
                     console.log('333333')
        }
      })
          
    })

  }
this.$loading().close()
 
},
    getList(){
      this.$loading({
            lock: true,
            text: '加载中...',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          });
      //  console.log(this.type)
      var date = new Date(this.date)
      var day = date.getDay()
    
      this.day = day
      // setTimeout(() => {
          
        if(this.type == 1){
          this.getDayList()
        } else {
          this.getWeeks()
        }
      // },1000)
    //  this.tableLoading = true
     
      
      
        
     
  
    },

    // 获取公司列表

    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.limit = parm.pageSize
      this.getProjectList()
    },
    // 搜索事件

    //显示编辑界面

    // 编辑、增加页面保存方法
    submitForm(editData) {

      this.$refs[editData].validate(valid => {
        if (valid) {
            var data =this.editForm
                data.token=localStorage.getItem("token")
                data.StoresID=localStorage.getItem("StoresID")
                data.SelectStoresID  = this.SelectStoresID
                var that = this
                
           
                if(this.editForm.Timelength == ''){
                  this.$message({ type: "error", message: "请输入时长" ,duration:1000});
                  return;
             }
              if(this.editForm.iscx == 0 && this.editForm.isck == 0 && this.editForm.IsPay == 0 && this.editForm.allCardName ==''  && objitems.allCardName){
                  this.$message({ type: "error", message: "请选择预约方式" ,duration:1000});
                  return;
                }
              if(this.editForm.RowClassTypeqt=='1' && this.editForm.RowClassType=='1'){
                    if(this.listRowClassTimeQT.length == 0){
                          this.$message({ type: "error", message: "请添加预约时间表" ,duration:1000});
                          return;
                    }
                }
              if(this.editForm.RowClassTypeqt=='2' && this.editForm.RowClassType=='1'){
                    if(this.listRowClassTime.length == 0){
                          this.$message({ type: "error", message: "请添加预约时间表" ,duration:1000});
                          return;
                    }
                }
              
                if(this.editForm.IsPay==1){
                    if(this.editForm.payPrice == 0){
                          this.$message({ type: "error", message: "请输入支付金额" ,duration:1000});
                          return;
                    }
                }


                  if(this.editForm.iscx == 0){
                        data.xhAmount = 0 
                  }
              if(this.editForm.isck == 0){
                        data.xhnumber = 0 
                  }
                var LoginIDs =''
                  this.LoginIDs.forEach(items => {
                        LoginIDs = LoginIDs +items.ID + ','
                  })
                  LoginIDs = LoginIDs.substring(0, LoginIDs.lastIndexOf(','));
                data.LoginIDs = LoginIDs
                if(localStorage.getItem("Iswyg") == 1){
                 if(data.LoginIDs ==''){
                      data.LoginIDs = 0
                 }
                    
                }else{
                if(data.LoginIDs ==''){
                   this.$message({ type: "error", message: "请选择员工" ,duration:1000});
                    return;
                  }
                   
                }
             
                 data.ListPreAboutForms = JSON.stringify(data.ListPreAboutForms)
                   var loading = this.$loading({
          lock: true,
          text: '加载中...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
          if(this.dateType == 1){
    if(this.editForm.RowClassTypeqt == 1){
                    let list = JSON.stringify(this.listRowClassTimeQT)
                    data.ListRowClassTime = list 
                    //  this.editForm.Timelengthqt =levels;
                      this.ajax('addRowClassQTdays.aspx',JSON.stringify(data),"POST",function(res){
                        if (res.orsuccess == "1") {
                            that.$message({
                                type: "success",
                                message: "新建成功",duration:2000,
                            });
                            that.editFormVisible = false
                            that.getList()
                        }

                    })
                  
                  } else {
                        let list = JSON.stringify(this.listRowClassTime)
                          data.ListRowClassTime = list
                          this.ajax('addRowClassdays.aspx',JSON.stringify(data),"POST",function(res){
                        if (res.orsuccess == "1") {
                            that.$message({
                                type: "success",
                                message: "新建成功",duration:2000,
                            });
                            that.editFormVisible = false
                            that.getList()
                        }

                    })
                    
                  }

          } else {
            if(this.editForm.RowClassTypeqt == 1){
                    let list = JSON.stringify(this.listRowClassTimeQT)
                    data.ListRowClassTime = list 
                    //  this.editForm.Timelengthqt =levels;
                      this.ajax('addRowClassQT.aspx',JSON.stringify(data),"POST",function(res){
                        if (res.orsuccess == "1") {
                            that.$message({
                                type: "success",
                                message: "新建成功",duration:2000,
                            });
                            that.editFormVisible = false
                            that.getList()
                        }

                    })
                  
                  } else {
                        let list = JSON.stringify(this.listRowClassTime)
                          data.ListRowClassTime = list
                          this.ajax('addRowClass.aspx',JSON.stringify(data),"POST",function(res){
                        if (res.orsuccess == "1") {
                            that.$message({
                                type: "success",
                                message: "新建成功",duration:2000,
                            });
                            that.editFormVisible = false
                            that.getList()
                        }

                    })
                    
                  }
          }
loading.close()
         
        } else {
          return false
          
        }
      })
    },
    sub(){
      var data = this.editForm
          data.token=localStorage.getItem("token")
          data.StoresID=localStorage.getItem("StoresID")
          data.SelectStoresID  = this.SelectStoresID
          data.RowClassID = data.ID
          data.iscz = this.iscz
          console.log(this.iscz)
          data.ListPreAboutForms = JSON.stringify(data.ListPreAboutForms)
          // console.log(ListPreAboutForms)
          var that = this
//                  if(this.editForm.Timelength == ''){
//                    this.$message({ type: "error", message: "请输入项目时长" ,duration:1000});
//                   return;
//              }
              if(this.editForm.RowClassTypeqt=='1' && this.editForm.RowClassType=='1'){
                    if(this.listRowClassTimeQT.length == 0){
                          this.$message({ type: "error", message: "请添加预约时间表" ,duration:1000});
                          return;
                    }
                }
              if(this.editForm.RowClassTypeqt=='2' && this.editForm.RowClassType=='1'){
                    if(this.listRowClassTime.length == 0){
                          this.$message({ type: "error", message: "请添加预约时间表" ,duration:1000});
                          return;
                    }
                }
                if(this.editForm.IsPay==1){
                    if(this.editForm.payPrice < 0){
                          this.$message({ type: "error", message: "请输入支付金额" ,duration:1000});
                          return;
                    }
                }
              if(this.editForm.isck==1){
                    if(this.editForm.xhnumber < 0){
                          this.$message({ type: "error", message: "请输入消耗次数" ,duration:1000});
                          return;
                    }
                }
             if(this.editForm.iscx == 0 && this.editForm.isck == 0 && this.editForm.IsPay == 0 && this.editForm.allCardName ==''  && objitems.allCardName){
                  this.$message({ type: "error", message: "请选择预约方式" ,duration:1000});
                  return;
                }
              if(this.editForm.iscx == 1){
                    if(this.editForm.xhAmount < 0){
                          this.$message({ type: "error", message: "请输入消耗金额" ,duration:1000});
                          return;
                    }
                }
                  if(this.editForm.iscx == 0){
                        data.xhAmount = 0 
                  }
                          if(this.editForm.isck == 0){
                        data.xhnumber = 0 
                  }
                              var loading = this.$loading({
          lock: true,
          text: '加载中...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
            if(this.editForm.RowClassTypeqt == 1){
                 let list = JSON.stringify(this.listRowClassTimeQT)
                data.ListRowClassTime = list 
                //  this.editForm.Timelengthqt =levels;
                  this.ajax('editRowClassQT.aspx',JSON.stringify(data),"POST",function(res){
                    if (res.orsuccess == "1") {
                        that.$message({
                            type: "success",
                            message: "修改成功",duration:2000,
                        });
                        that.editShow = false
                        that.getList()
                     }

                })
              
              } else {
               
                   
                   // let list = JSON.stringify(this.listRowClassTime)
                   let list = JSON.stringify(this.listRowClassTimeCopy)

                      data.ListRowClassTime = list
                       this.ajax('editRowClass.aspx',JSON.stringify(data),"POST",function(res){
                    if (res.orsuccess == "1") {
                        that.$message({
                            type: "success",
                            message: "修改成功",duration:2000,
                        });
                        that.editShow = false
                        that.getList()
                     }

                })
                
              }
    loading.close()
    },
    closeDialog1(){
        this.objShow = false
        this.preShow = false
    },
    // 关闭编辑、增加弹出框
    closeDialog() {
    
        
      this.passShow = false
      this.chongShow = false
      this.editFormVisible = false
    }
  }
}
</script>

<style>

.bcss{
  position: absolute;
  font-weight:600;
  font-size:16px;
  z-index:99;
  background-color:white
}
::-webkit-scrollbar  
{  
   
    width: 6px;
    height: 6px;  
    /* background-color: #F5F5F5;   */
}
::-webkit-scrollbar-thumb {

    border-radius: 10px !important;
    background: rgba(0,0,0,.25) !important;
}
</style>
<style scoped>


.isFixed {
  position: fixed;
  left: 0;
  top: 0;
  z-index: 9999;
 }
.leftMain{
  width: 100%;
  height: 100%;
  /* padding-bottom: -8px; */
  overflow: auto;
  overflow-x:auto
}
.da{

  /* height:70vh; */
  width: 99%;
  height:calc(75vh - 100px);
  overflow: hidden;

}

.main{
    /* overflow-x: auto; */
    border:1px solid #e2e2e2;
    overflow:hidden;
    height: 99%;
    /* margin-top:20px; */
    width: 100%;
  
    position: relative;
  
}
.postMain{
  position: absolute;
  background-color: white;
  overflow:hidden;
  height:calc(100% - 6px);
   /* overflow-y: auto */
}
.hov:hover{
  background-color: #c6def1;
}
.quanbu{
  position:absolute;
  bottom: 0;
  left: 0;
  font-size: 10px;
  color: #bebebe;
}
.boxMain{
  position: relative;
}
  .qiu{
    width: 15px;
    height: 15px;
    margin-left: 5px;
    border-radius: 100%;
     
  }
.f-mt-10 {
    margin-top: 10px;
}
.itemWrap___33SF3 {
    text-align: left;
    margin-bottom: 8px;
    padding: 0 12px;
    line-height: 40px;
    background: #e6f7ff;
    border-radius: 8px;
 }
.itemWrap___33SF31 {
    text-align: left;
    margin-bottom: 8px;
    margin-left: 10px;
    padding: 0 12px;
    line-height: 40px;
    background: #e6f7ff;
    border-radius: 8px;
     width: 60px;
}
.itemWrap___33SF31 {
    text-align: left;
    margin-bottom: 8px;
    margin-left: 10px;
    padding: 0 12px;
    line-height: 40px;
    background: #e6f7ff;
    border-radius: 8px;
     width: 60px;
}
.g-items-wrap {
    padding: 10px 15px;
    border: 1px dashed #40a9ff;
}
.f-mt-10 {
    margin-top: 10px;
}
.dialogMain{
    overflow: auto;
}
.dilag-fix{
    position:absolute;
    right: 0;
    bottom: 0;
    margin-bottom: 10px;

}
.mian{
  height: 300px;
    overflow: auto;
  overflow-x: hidden
 
}
.hen{
  width: 95%;
  border: 1px dashed #65a8ff;
  margin-left: 2.5%;
  padding-top:10px;
  padding-bottom: 10px;
}
.mainTitle{
  border-radius: 5px;
  width: 95%;
  height: 95%;
  background-color: white;
}
.left{
  background-color: #e0e0e0;
}
.jingp{
  width:50px;

  margin-left: 10px;
  font-size: 13px;
}
.kuai{
  margin-left: 10px;
  border-radius: 20px;
  width: 20px;
  height: 20px;
}
.bgColor{
  width:215px;
  height:30px;
  border:1px solid #808080;
  margin-top:5px;
  border-radius: 4px;
}
.topTime{
  position: absolute;
  overflow: hidden;
}
.maxw{

     display: flex;   

     /* -ms-flex-wrap: wrap;
     flex-wrap: wrap;
     -webkit-box-pack: start;
     -ms-flex-pack: start;
     justify-content: flex-start; */
  
}

.box{
    min-width:200px;
    width:20px;
    height:50px;
    border-bottom:6px solid #f5f4f4;
    border-right:1px solid #e2e2e2;
    font-size: 14px;

}
.box1{
    min-width:200px;
    width:20px;
    background: white;
    height:120px;
    font-size: 14px;
    border-right:1px solid #e2e2e2;
    border-bottom:6px solid #f5f4f4;
}
.top{
    border-top:1px solid #e2e2e2;
    border-top:1px solid #e2e2e2;
    /* padding-top:20px; */
    margin-top: 15px;
}

.userRole {
  width: 100%;
}
.qie{
  color:#65a8ff;
  font-weight: 500;
  font-size: 16px;
  
}
</style>



// WEBPACK FOOTER //
// src/views/arrange/arrange.vue